import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/spinner/Spinner";
import "./../businessProfileConnect/BusinessProfileConnect.css";
import { Fragment } from "react";
import "./GridReportTool.css";
import { GetSalesBusiness, RemoveSalesBusiness, StoreSalesBusiness } from "../../../utils/StorageUtil";
import GridMapV5 from "../../../components/gridReport/v5/gridMap/GridMapV5";
import { toast } from "react-toastify";
import {
    CreateSalesCompany,
    CreateSalesCompanyTask,
    CreateSalesCompanyTaskQueue,
    DeductUserReportCredits,
    DeleteSalesCompanyTask,
    GetAdminDefaultSettings,
    GetReportSettings,
    GetSalesCompanyDetails,
    GetSalesCompanyDetailsBasic,
    GetSalesCompanyTaskDetailsWithSproc,
    GetSalesCompanyTaskDetailsWithSprocBasic,
    GetSalesCompanyTasks,
    GetTaskQueuesByCompanyId,
    UpdateSalesCompany,
    UpdateSalesCompanyTask,
    UpdateSalesCompanyTaskLocation,
} from "../../../Services";
import { useStateValue } from "../../../StateProvider";
import { capitalize, copyToClipboard, createGuid, getHighlightedText, isNumber, slugify } from "../../../utils/Common";
import moment from "moment";
import html2canvas from "html2canvas";
import {
    GenerateReportData,
    GetReportAnalizedSummaryData,
    GetNormalizedReportDataByCompanyId,
    GetReportsByCompanyId,
} from "../../../ReportAPI";
import ModalDialog from "../../../components/modalDialog/ModalDialog";
import ModalDialogContent from "../../../components/modalDialog/modalDialogContent/ModalDialogContent";
import ModalDialogButtons from "../../../components/modalDialog/modalDialogButtons/ModalDialogButtons";

const GridReportTool = ({ isEdit = false }) => {
    const [{ user, host, appVersion }, dispatch] = useStateValue();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMap, setIsLoadingMap] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isGeneratingAudit, setIsGeneratingAudit] = useState(false);
    const [isLoadingAuditData, setIsLoadingAuditData] = useState(false);
    const [isUpdatingAudit, setIsUpdatingAudit] = useState(false);
    const [selectedBusiness, setSelectedBusiness] = useState();
    const [companyId, setCompanyId] = useState();
    const [companyData, setCompanyData] = useState();
    const [areaRadius, setAreaRadius] = useState();
    const [keywords, setKeywords] = useState();
    const [keywordsArray, setKeywordsArray] = useState();
    const [selectedTask, setSelectedTask] = useState();
    const [selectedTaskGridData, setSelectedTaskGridData] = useState();
    const navigate = useNavigate();
    const [showGridReport, setShowGridReport] = useState(true);
    const [reportTasks, setReportTasks] = useState();
    const [dateCreated, setDateCreated] = useState();
    const [gridData, setGridData] = useState();
    const [adminSettings, setAdminSettings] = useState();
    const [powerCitationsWebsites, setPowerCitationsWebsites] = useState();
    const [powerContentWebsites, setPowerContentWebsites] = useState();
    const [reportSettings, setReportSettings] = useState();
    const { reportId, selectedCompanyId } = useParams();
    const [showShareLinkCopiedMessage, setShowShareLinkCopiedMessage] = useState(false);
    const [changesMade, setChangesMade] = useState(false);
    const [selectedIndustryCategory, setSelectedIndustryCategory] = useState();
    const [industryCategories, setIndustryCategories] = useState([]);
    const [selectedIndustryCategoryIdForm, setSelectedIndustryCategoryIdForm] = useState();
    const [auditReportsList, setAuditReportsList] = useState();
    const [auditResponseData, setAuditResponseData] = useState();
    const [auditKeywordData, setAuditKeywordData] = useState();
    const [auditFormData, setAuditFormData] = useState({});
    const [showJsonOutputDialog, setShowJsonOutputDialog] = useState(false);
    const [jsonOutput, setJsonOutput] = useState();
    const [competitorsData, setCompetitorsData] = useState();
    const [competitorsDataForAllKeywords, setCompetitorsDataForAllKeywords] = useState();
    const [competitorsDataForCopy, setCompetitorsDataForCopy] = useState();
    const [showCompetitorsPanel, setShowCompetitorsPanel] = useState(false);
    const [selectedCompetitorOnMap, setSelectedCompetitorOnMap] = useState();
    const [selectedKeyword, setSelectedKeyword] = useState();
    const [summaryData, setSuummaryData] = useState();
    const [summaryChecklistItems, setSummaryChecklistItems] = useState();
    const [summaryChecklistItemsByKeyword, setSummaryChecklistItemsByKeyword] = useState();
    const [summaryCompetitionItems, setSummaryCompetitionItems] = useState();
    const [summaryCompetitionItemsByKeyword, setSummaryCompetitionItemsByKeyword] = useState();
    const [businessGridAverageData, setBusinessGridAverageData] = useState();
    const [businessGridAverageDataByKeyword, setBusinessGridAverageDataByKeyword] = useState();
    const [taskLocation, setTaskLocation] = useState();
    const [alsoGenerateAuditReport, setAlsoGenerateAuditReport] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState();
    const [companyTaskQueues, setCompanyTaskQueues] = useState();
    const gridMapContainerRef = useRef();

    const settings = [
        { label: "Categories", propName: "categories", printPropName: "profile.categories", checkboxName: "Profile" },
        { label: "Address", propName: "address", printPropName: "profile.address" },
        { label: "Phone Number", propName: "phoneNumber", printPropName: "profile.phone" },
        { label: "Website URL", propName: "websiteUrl", printPropName: "profile.website" },
        { label: "Contact URL", propName: "contactUrl", printPropName: "profile.contactUrl" },
        { label: "Description", propName: "description", printPropName: "profile.description", shouldTruncate: false },
        { label: "Business Hours", propName: "businessHours", printPropName: "workTime" },
        { label: "Total Reviews", propName: "totalReviews", printPropName: "reviews" },
        { label: "Total Posts", propName: "totalPosts", printPropName: "posts", checkboxName: "TotalPosts" },
        { label: "Total Q&A", propName: "totalQA", printPropName: "qa", checkboxName: "TotalQA" },
        { label: "Total Images", propName: "totalPhotos" },
        { label: "Logo", propName: "logo", printPropName: "profile.logo" },
        { label: "Main Image", propName: "mainImage", printPropName: "profile.mainImage" },
        { label: "Social Profiles", propName: "socialProfiles", printPropName: "profile.socialProfiles" },
    ];
    const kwSettings = [
        {
            label: "Profile Categories",
            propName: "keywordInCategories",
            printPropName: "profile.categories",
            hoverPropName: "occurrencesInCategories",
            highlightText: true,
        },
        {
            label: "Profile Title",
            propName: "keywordInTitle",
            printPropName: "profile.title",
            hoverPropName: "occurrencesInTitle",
            highlightText: true,
        },
        {
            label: "Profile Description",
            propName: "keywordInDescription",
            printPropName: "profile.description",
            hoverPropName: "occurrencesInDescription",
            shouldTruncate: false,
            highlightText: true,
        },
        {
            label: "Profile Reviews (Last 20)",
            propName: "keywordInReviews",
            printPropName: "reviews.last20",
            hoverPropName: "occurrencesInReviews",
            checkboxName: "TotalReviews",
            highlightText: true,
        },
        {
            label: "Profile Posts",
            propName: "keywordInPosts",
            printPropName: "posts",
            hoverPropName: "occurrencesInPosts",
            checkboxName: "TotalPosts",
            highlightText: true,
        },
        {
            label: "Profile Q&A",
            propName: "keywordInQA",
            printPropName: "qa",
            hoverPropName: "occurrencesInQA",
            checkboxName: "TotalQA",
            highlightText: true,
        },
        {
            label: "Website Landing Page",
            propName: "keywordInWebsiteLandingPage",
            // printPropName : 'occurrencesInHtml',
            hoverPropName: "occurrencesInHtml",
            checkboxName: "KeywordDensityOnLandingPage",
            highlightText: true,
        },
        {
            label: "Website Pages Indexed",
            propName: "keywordWebsitePagesIndexed",
            printPropName: "indexedPagesByKeyword.results",
            hoverPropName: "occurrencesInIndexedPages",
            checkboxName: "IndexedPagesByKeyword",
            // highlightText : true
        },
    ];
    const reviewsLast20Settings = [
        { label: "Average Rating", propName: "last20AverageRating" },
        { label: "Average Words Per Review", propName: "last20AverageWordsPerReview" },
        // { label: 'Have Replies', propName: 'last20HaveReplies' },
        { label: "Do Not Have Replies", propName: "last20DoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last20LocalGuideReviews" },
        { label: "Negative Reviews", propName: "last20NegativeReviews" },
        // { label: 'Negative Reviews Have Replies', propName: 'last20NegativeReviewsHaveReplies' },
        { label: "Negative Reviews Do Not Have Replies", propName: "last20NegativeReviewsDoNotHaveReplies" },
    ];
    const reviewsLast30DaysSettings = [
        { label: "Total Reviews", propName: "last30TotalReviews" },
        { label: "Average Rating", propName: "last30AverageRating" },
        { label: "Average Words Per Review", propName: "last30AverageWordsPerReview" },
        // { label: 'Have Replies', propName: 'last30HaveReplies' },
        { label: "Do Not Have Replies", propName: "last30DoNotHaveReplies" },
        { label: "Local Guide Reviews", propName: "last30LocalGuideReviews" },
        { label: "Negative Reviews", propName: "last30NegativeReviews" },
        // { label: 'Negative Reviews Have Replies', propName: 'last30NegativeReviewsHaveReplies' },
        { label: "Negative Reviews Do Not Have Replies", propName: "last30NegativeReviewsDoNotHaveReplies" },
    ];

    useEffect(() => {
        getAdminSettings();
        getReportSettings();
    }, []);

    //isEdit
    useEffect(() => {
        if (isEdit) {
            setIsLoadingMap(true);
            setShowGridReport(false);
        }
    }, [isEdit]);

    //reportId
    useEffect(() => {
        if (reportId) {
            getReportTaskDetails(reportId, true);
        }
    }, [reportId]);

    //new report
    useEffect(() => {
        if (selectedCompanyId) {
            setIsLoadingMap(true);
            setShowGridReport(false);
            getCompanyDetails(selectedCompanyId);
            getCompanyReportTasks(selectedCompanyId);
            getTaskQueuesByCompanyId(selectedCompanyId);
        }
    }, [selectedCompanyId]);

    useEffect(() => {
        if (!reportId && !selectedCompanyId) {
            setIsLoadingMap(true);
            setShowGridReport(false);

            let tempBusiness = GetSalesBusiness();

            if (tempBusiness) {
                setSelectedBusiness(tempBusiness);

                setAreaRadius(tempBusiness.isServiceArea ? 7 : 2.5);

                setGridData({
                    googlePlaceId: tempBusiness.place_id,
                    lat: tempBusiness.lat,
                    lng: tempBusiness.lng,
                });
            }

            setIsLoading(false);
            setIsLoadingMap(false);
        }
    }, []);

    //mapReady event
    useEffect(() => {
        if (window.mapReady) {
            setIsLoadingMap(false);
        }
    }, [window.mapReady]);

    //grid data default values
    useEffect(() => {
        if (selectedBusiness) {
            setGridData({
                googlePlaceId: selectedBusiness.place_id,
                lat: selectedBusiness.lat,
                lng: selectedBusiness.lng,
            });
        }
    }, [areaRadius, selectedBusiness]);

    //get competitors data
    useEffect(() => {
        if (companyData && selectedTaskGridData) {
            getCompetitorsData(selectedTaskGridData);
        }
    }, [selectedTaskGridData]);

    //get audit data
    useEffect(() => {
        if (selectedTask && companyId && !isEdit) {
            // get grid data
            getReportGridData(selectedTask.id);

            getTaskQueuesByCompanyId(companyId);
            getAuditReports(companyId, true);
            getNormalizedReportData(companyId, selectedTask.id);
            getReportAnalizedSummaryData(selectedTask.id);
        }
    }, [selectedTask, companyId]);

    //uncheck all audit items on load
    useEffect(() => {
        if (auditKeywordData) {
            uncheckAllItems();
        }
    }, [auditKeywordData]);

    const getCompanyDetails = async (id) => {
        let response = await GetSalesCompanyDetailsBasic(id);

        if (response) {
            setCompanyData(response);
            setCompanyId(response.id);

            if (isEdit) {
                setGridData({
                    googlePlaceId: response.googlePlaceId,
                    lat: response.lat,
                    lng: response.lng,
                });
            }
        }
    };

    const getCompanyReportTasks = async (id) => {
        let response = await GetSalesCompanyTasks(id);

        if (response && response.length > 0) {
            let tempTasks = response;
            let tempTask;

            if (tempTasks.length > 0) {
                //sort by date desc
                tempTasks = tempTasks.sort(function (a, b) {
                    return new Date(b.dateCreated) - new Date(a.dateCreated);
                });

                setReportTasks(tempTasks);

                tempTask = tempTasks[0];
            }
        } else {
            setAreaRadius(5);
        }
    };

    //get audit data
    useEffect(() => {
        if (companyData && selectedCompanyId) {
            if (reportTasks && reportTasks.length > 0) {
                let lastTask = reportTasks[0];

                setAreaRadius(lastTask.gridRadius);

                if (lastTask.keyword) {
                    setKeywords(lastTask.keyword);
                    setKeywordsArray(lastTask.keyword.split("\n"));
                }
            }

            setGridData({
                googlePlaceId: companyData.googlePlaceId,
                lat: companyData.lat,
                lng: companyData.lng,
            });

            setIsLoading(false);
        }
    }, [companyData, reportTasks]);

    const getReportTaskDetails = async (id) => {
        setIsLoading(true);

        let response = await GetSalesCompanyTaskDetailsWithSprocBasic(id);

        if (response) {
            let tempTask = response;

            setSelectedTask(tempTask);
            setReportTasks([tempTask]);

            setTaskLocation(tempTask.location);

            if (tempTask.salesCompanyId) {
                setCompanyId(tempTask.salesCompanyId);
                await getCompanyDetails(tempTask.salesCompanyId);
            }

            setAreaRadius(tempTask.gridRadius);

            setDateCreated(tempTask.lastUpdated || tempTask.dateCreated);

            if (tempTask.keyword) {
                setKeywords(tempTask.keyword);

                let tempKeywordsArray = tempTask.keyword.split("\n").map((x) => x.trim());

                if (tempKeywordsArray && tempKeywordsArray.length) {
                    setSelectedKeyword(tempKeywordsArray[0]);
                    setKeywordsArray(tempKeywordsArray);
                }
            }
        }

        setIsLoading(false);
    };

    const getReportGridData = async (id) => {
        setLoadingMessage("loading grid data...");
        let response = await GetSalesCompanyTaskDetailsWithSproc(id);

        if (response) {
            let tempTask = response;

            if (tempTask.content) {
                let gridReportData = JSON.parse(tempTask.content);

                //for backward compatibility for each point result add properties place_id and data_cid
                if (gridReportData.gridResponse && gridReportData.gridResponse.data) {
                    gridReportData.gridResponse.data.forEach((keywordGridData) => {
                        if (keywordGridData && keywordGridData.points) {
                            keywordGridData.points.forEach((point) => {
                                if (point.results && point.results.length) {
                                    point.results.forEach((pointResult) => {
                                        if (!pointResult.place_id && pointResult.placeId) {
                                            pointResult.place_id = pointResult.placeId;
                                        }

                                        if (!pointResult.data_cid && pointResult.dataCid) {
                                            pointResult.data_cid = pointResult.dataCid;
                                        }
                                    });
                                }
                            });
                        }
                    });
                }

                if (gridReportData) {
                    setSelectedTaskGridData(gridReportData);

                    setGridData({
                        googlePlaceId: gridReportData.googlePlaceId,
                        lat: tempTask.lat,
                        lng: tempTask.lng,
                        horizontalPoints: tempTask.gridPoints,
                        verticalPoints: tempTask.gridPoints,
                        ...(gridReportData.gridResponse && gridReportData.gridResponse.data ? gridReportData.gridResponse.data[0] : null),
                    });

                    setIsLoadingMap(false);
                }
            } else {
                setIsLoadingMap(false);
            }
        } else {
            setIsLoadingMap(false);
        }
    };

    const getAdminSettings = async () => {
        let response = await GetAdminDefaultSettings();

        if (response && response.data) {
            setAdminSettings(response.data);
            setIndustryCategories(response.data.industryCategories);

            //set default selected industry category to "Default"
            if (response.data.industryCategories && response.data.industryCategories.length) {
                setSelectedIndustryCategoryIdForm(response.data.industryCategories.find((x) => x.categoryName === "Default").categoryGuid);
            }
        }
    };

    //get power citations and content websites for selected industry
    useEffect(() => {
        if (adminSettings && selectedIndustryCategory) {
            let category = adminSettings.industryCategories.find((x) => x.categoryGuid === selectedIndustryCategory);

            if (
                category &&
                category.websites &&
                category.websites.length &&
                adminSettings.powerWebsites &&
                adminSettings.powerWebsites.length
            ) {
                let tempCitationsWebsites = [];
                let tempContentWebsites = [];

                let allCitationsWebsites = adminSettings.powerWebsites.filter((x) => x.websiteIsCitations === true);
                if (allCitationsWebsites && allCitationsWebsites.length) {
                    allCitationsWebsites.forEach((website) => {
                        if (category.websites.includes(website.websiteGuid) && !tempCitationsWebsites.includes(website)) {
                            tempCitationsWebsites.push(website);
                        }
                    });
                }

                let allContentWebsites = adminSettings.powerWebsites.filter((x) => x.websiteIsContent === true);
                if (allContentWebsites && allContentWebsites.length) {
                    allContentWebsites.forEach((website) => {
                        if (category.websites.includes(website.websiteGuid) && !tempContentWebsites.includes(website)) {
                            tempContentWebsites.push(website);
                        }
                    });
                }

                setPowerCitationsWebsites(tempCitationsWebsites);
                setPowerContentWebsites(tempContentWebsites);
            }
        }
    }, [selectedIndustryCategory, adminSettings]);

    const getReportSettings = async () => {
        let response = await GetReportSettings();

        if (response && response.data) {
            setReportSettings(response.data);
        }
    };

    const handleSelectKeyword = (keywordName) => {
        setSelectedKeyword(keywordName);
    };

    //handle selected keyword
    useEffect(() => {
        if (selectedKeyword && selectedTaskGridData) {
            let tempSelectedTaskGridData = { ...selectedTaskGridData };

            let tempGridData = tempSelectedTaskGridData.gridResponse.data.filter(
                (k) => k.keyword.trim().toLowerCase() === selectedKeyword.trim().toLowerCase(),
            );

            setGridData({
                googlePlaceId: tempSelectedTaskGridData.googlePlaceId,
                lat: tempSelectedTaskGridData.gridResponse.lat,
                lng: tempSelectedTaskGridData.gridResponse.lng,
                horizontalPoints: tempSelectedTaskGridData.gridResponse.horizontalPoints,
                verticalPoints: tempSelectedTaskGridData.gridResponse.verticalPoints,
                ...(tempGridData && tempGridData.length ? tempGridData[0] : null),
            });

            getCompetitorsData(tempSelectedTaskGridData);
            // getReportAnalizedSummaryData(selectedTask.id);

            //set business grid average
            if (businessGridAverageData && businessGridAverageData.length) {
                let tempBusinessGridAverageDataByKeyword = businessGridAverageData.find((x) => x.keyword.trim() === selectedKeyword.trim());
                if (tempBusinessGridAverageDataByKeyword) {
                    setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
                }
            }

            setSelectedCompetitorOnMap();
        }
    }, [selectedKeyword]);

    const handleChange = async (e) => {
        if (e.target.name === "areaRadius") {
            setAreaRadius(e.target.value);
            setChangesMade(true);
        } else if (e.target.name === "keywords") {
            setKeywords(e.target.value);
        } else if (e.target.name === "industryCategoryIdForm") {
            setSelectedIndustryCategoryIdForm(e.target.value);
        }
    };

    const generateGridReportNEW = async (e) => {
        e.preventDefault();

        if (!keywords || keywords.trim() === "") {
            toast.error("Enter at least one keyword to continue");
            return;
        }

        let keywordsArrayForReport = [];
        let lastReport;
        let lastReportDate;

        if (reportTasks && reportTasks.length > 0) {
            lastReport = reportTasks[0];
            lastReportDate = lastReport.lastUpdated || lastReport.dateCreated;
        } else if (selectedTask) {
            lastReport = selectedTask;
            lastReportDate = lastReport.lastUpdated || lastReport.dateCreated;
        }

        if (isEdit && changesMade) {
            //radius has changed, thus create report for all keyword
            keywordsArrayForReport = keywords
                .trim()
                .split("\n")
                .map((x) => x.trim());
        } else if (isEdit && !changesMade) {
            //don't run reports if radius or keywords didn't change
            toast.error("No changes made in the report settings");
            return;

            if (keywords && lastReportDate) {
                // //check the date of the last report
                // if (moment(lastReportDate).add(7, 'days').isAfter(moment(), 'day')) {
                // 	//task exists for this keyword, but it was created more than 7 days ago
                // 	toast.error('The last report was created less than 7 days ago');
                // 	return;
                // }
            }
        } else {
            keywordsArrayForReport = keywords
                .trim()
                .split("\n")
                .map((x) => x.trim());
        }

        if (keywordsArrayForReport && keywordsArrayForReport.length > 5) {
            toast.error("You can set max 5 keywords");
            return;
        }

        if (isEdit && keywordsArrayForReport.length === 0 && lastReport) {
            //no any keyword changed or all keywords ran in the last 7 days, just redirect to last report
            window.location.href = `${host}/reports/${lastReport.id}`;
        }

        setIsGenerating(true);

        //calculate grid points based on radius
        let gridPoints = 7;

        if (areaRadius > 5) {
            gridPoints = 9;
        } else if (areaRadius > 10) {
            gridPoints = 11;
        }

        let pointDistance = parseFloat((areaRadius * 2) / (gridPoints - 1));
        let tempCompany = { ...companyData };

        //update lat/lng if changed
        if (tempCompany && gridData && gridData.lat && gridData.lat !== tempCompany.lat) {
            tempCompany.lat = gridData.lat;
            tempCompany.lng = gridData.lng;

            await UpdateSalesCompany(tempCompany.id, tempCompany);
        }

        if (!tempCompany && selectedBusiness) {
            let email =
                selectedBusiness.name
                    .toLowerCase()
                    .replace(/ /g, "")
                    .replace(/[^\w-]+/g, "") + "@realwebsite.com";

            //first create company if it doesn't exist
            let companyData = {
                ...selectedBusiness,
                userId: user.id,
                salesRepId: selectedBusiness.salesUserId ? selectedBusiness.salesUserId : user.id,
                email: email,
                phone: selectedBusiness.formatted_phone_number,
                googleCid: selectedBusiness.cid,
                googlePlaceId: selectedBusiness.place_id,
                googleBusinessUrl: selectedBusiness.googleBusinessUrl
                    ? selectedBusiness.googleBusinessUrl
                    : selectedBusiness.cid
                      ? "https://maps.google.com/?cid=" + selectedBusiness.cid
                      : "",
                status: "Active",
            };

            const companyResponse = await CreateSalesCompany(companyData);

            if (!companyResponse.success) {
                if (
                    companyResponse.data &&
                    companyResponse.message.indexOf("already exists") > -1 &&
                    companyResponse.data.userId === user.id
                ) {
                    tempCompany = companyResponse.data;

                    //update lat and lng if necessary
                    if (selectedBusiness && selectedBusiness.lat !== tempCompany.lat) {
                        tempCompany.lat = selectedBusiness.lat;
                        tempCompany.lng = selectedBusiness.lng;

                        const updateCompanyResponse = await UpdateSalesCompany(tempCompany.id, tempCompany);

                        if (!updateCompanyResponse.success) {
                            console.log("Company lat/lng not updated. Reason: " + updateCompanyResponse.message);
                        }
                    }
                }
            } else {
                tempCompany = companyResponse.data;
            }

            setCompanyData(tempCompany);
            setCompanyId(tempCompany.id);
        }

        if (tempCompany) {
            //create task
            let taskData = {
                salesCompanyId: tempCompany.id,
                keyword: keywordsArrayForReport.join("\n"),
                lat: tempCompany.lat,
                lng: tempCompany.lng,
                gridPoints: gridPoints,
                gridPointsDistanceInMiles: pointDistance,
                gridRadius: areaRadius,
                orderIndex: 0,
                industryCategoryId: selectedIndustryCategoryIdForm,
            };

            let taskResponse;

            if (isEdit) {
                taskData.id = selectedTask.id;
                taskResponse = await UpdateSalesCompanyTask(taskData.id, taskData);
            } else {
                taskData.id = createGuid();
                taskResponse = await CreateSalesCompanyTask(taskData);
            }

            if (taskResponse.success) {
                await addReportToQueue(taskData.id, alsoGenerateAuditReport ? "Grid|Audit" : "Grid");

                //deduct user subscription credits
                await deductUserReportCredits(true, alsoGenerateAuditReport);
            } else {
                setIsGenerating(false);
            }
        } else {
            setIsGenerating(false);
        }
    };

    const addReportToQueue = async (taskId, action) => {
        let data = {
            salesCompanyTaskId: taskId,
            salesUserId: user && user.isSalesUser ? user.id : null,
            action: action,
            status: "Pending",
        };

        let response = await CreateSalesCompanyTaskQueue(taskId, data);

        if (response.success) {
            await getTaskQueuesByCompanyId(companyId);
            setIsGenerating(false);
            toast.success("Report added to the queue.");
        }
    };

    const deductUserReportCredits = async (deductGridCredits, deductAuditCredits) => {
        let data = {
            id: user.id,
            deductGridReportCredit: deductGridCredits,
            deductAuditReportCredits: deductAuditCredits,
            deductCampaignReportCredits: null,
        };

        let response = await DeductUserReportCredits(data);

        if (response.success) {
        }
    };

    const getTaskQueuesByCompanyId = async (id) => {
        let response = await GetTaskQueuesByCompanyId(id);
        if (response && response.length > 0) {
            //sort by date desc
            response = response.sort(function (a, b) {
                return new Date(b.dateCreated) - new Date(a.dateCreated);
            });

            //get only Processing or Pending
            response = response.filter((x) => x.status === "Processing" || x.status === "Pending");

            setCompanyTaskQueues(response);
        }
    };

    const getReportShareLink = () => {
        var url = new URL(
            `https://${host.indexOf("dev-") > -1 ? "dev-" : ""}report.localrankreport.com/public/reports/audit/${selectedTask.id}`,
        );

        copyToClipboard(url.href);

        setShowShareLinkCopiedMessage(true);

        setTimeout(function () {
            setShowShareLinkCopiedMessage(false);
        }, 1000);
    };

    const exportMapAsImage = () => {
        setIsLoadingMap(true);

        let companySlug = slugify(companyData.name);
        let date = moment().format("MMDDYYYYHHmm");
        let imageName = showGridReport
            ? `exported-grid-${companySlug}-${slugify(selectedKeyword)}-${date}.png`
            : `exported-map-${companySlug}-${date}.png`;

        let $mapContainer = showGridReport ? document.querySelector("#report-map-0") : document.querySelector("#report-map-preview");

        if ($mapContainer) {
            gridMapContainerRef.current.classList.add("no-transition");

            html2canvas($mapContainer, { useCORS: true })
                .then((canvas) => {
                    var imgSrc = canvas.toDataURL("image/png");

                    var link = document.createElement("a");
                    if (typeof link.download !== "string") {
                        window.open(imgSrc);
                    } else {
                        link.href = imgSrc;
                        link.download = imageName;
                        link.click();
                        //accountForFirefox(clickLink, link);
                    }

                    setIsLoadingMap(false);
                })
                .finally(() => {
                    gridMapContainerRef.current.classList.remove("no-transition");
                    setIsLoadingMap(false);
                });
        }
    };

    const handleCircleMove = (center) => {
        if (center) {
            if (isEdit) {
                setGridData({
                    ...gridData,
                    lat: center.lat,
                    lng: center.lng,
                });
            } else {
                let tempBusiness = { ...selectedBusiness };

                tempBusiness.lat = center.lat;
                tempBusiness.lng = center.lng;

                setSelectedBusiness(tempBusiness);

                StoreSalesBusiness(tempBusiness);
            }
        }
    };

    const generateAuditDataNEW = async () => {
        setIsGenerating(true);

        let taskId = selectedTask.id;
        await addReportToQueue(taskId, "Audit");

        //deduct user subscription credits
        await deductUserReportCredits(null, true);

        setIsGenerating(false);
    };

    const updateAuditData = async () => {
        if (!selectedIndustryCategory || selectedIndustryCategory.trim() === "") {
            toast.error("You have to select an industry first");
            return;
        }

        if (companyData) {
            setIsUpdatingAudit(true);

            let tempCompetitorsData = {};

            if (competitorsDataForAllKeywords && competitorsDataForAllKeywords.length > 0) {
                competitorsDataForAllKeywords.forEach((x) => {
                    //add max 3 competitors place Ids
                    if (x.competitorsData && x.competitorsData.length > 0) {
                        let competitorsPlaceIds = [];

                        x.competitorsData.forEach((competitor) => {
                            if (
                                competitor.place_id &&
                                !competitorsPlaceIds.includes(competitor.place_id) &&
                                competitorsPlaceIds.length < 3
                            ) {
                                competitorsPlaceIds.push(competitor.place_id);
                            }
                        });

                        tempCompetitorsData[x.keyword.trim()] = competitorsPlaceIds;
                    }
                });
            }

            let data = {
                ...auditFormData,
                companyId: companyId,
                salesCompanyTaskId: selectedTask.id,
                industryCategoryId: selectedIndustryCategory,
                businessPlaceId: companyData.googlePlaceId,
                keywordsCompetitorsData: tempCompetitorsData,
                isUpdate: true,
            };

            let response = await GenerateReportData(data);

            if (response.success && response.data) {
                getAuditReports(companyId, true);
            }

            setIsUpdatingAudit(false);
        }
    };

    const getAuditReports = async (id, loadFirstReport = false) => {
        let response = await GetReportsByCompanyId(id);

        if (response.success && response.data) {
            setAuditReportsList(response.data);

            if (response.data.length && loadFirstReport) {
                //getNormalizedReportData(id, response.data[0].reportName);
                getNormalizedReportData(id, selectedTask.id);
            }
        } else {
            setAuditReportsList();
        }
    };

    const getNormalizedReportData = async (id, reportName) => {
        setIsLoadingAuditData(true);

        let response = await GetNormalizedReportDataByCompanyId(id, reportName);

        if (response.success) {
            // console.log(response.data);
            setAuditResponseData(response.data);

            if (response.data && response.data.length > 0 && response.data[0].businessData && response.data[0].businessData.inputData) {
                setSelectedIndustryCategory(response.data[0].businessData.inputData.industryCategoryId);
            }
        } else {
            setAuditResponseData();
            setSelectedIndustryCategory();
        }

        setIsLoadingAuditData(false);
    };

    const saveTaskLocation = async () => {
        if (selectedTask) {
            if (!taskLocation || taskLocation.trim() === "") {
                toast.error("Please enter location");
                return;
            }

            let data = {
                ...selectedTask,
                location: taskLocation,
            };

            let response = await UpdateSalesCompanyTaskLocation(selectedTask.id, data);

            if (response.success) {
                toast.success("Location updated successfully.");
            }
        }
    };

    //audit response data
    useEffect(() => {
        if (auditResponseData) {
            let tempAuditResponseData = [...auditResponseData];

            //get data for selected keyword
            let tempAuditResponseKwData = tempAuditResponseData.find((x) => x.keyword.trim() === selectedKeyword.trim());

            if (tempAuditResponseKwData) {
                //build business and competitors data as array items to display data easier
                let tempAuditKeywordData = [];
                tempAuditKeywordData.push(tempAuditResponseKwData.businessData);

                if (tempAuditResponseKwData.competitorsData && tempAuditResponseKwData.competitorsData.length > 0) {
                    tempAuditResponseKwData.competitorsData.map((comp) => {
                        tempAuditKeywordData.push(comp);
                    });
                }

                //set minimal timeout to see the spinner
                setIsLoadingAuditData(true);
                setTimeout(function () {
                    setAuditKeywordData(tempAuditKeywordData);
                    setIsLoadingAuditData(false);
                }, 300);
            }
        }
    }, [auditResponseData, selectedKeyword]);

    const getReportAnalizedSummaryData = async (reportName) => {
        let response = await GetReportAnalizedSummaryData(companyId, reportName);
        if (response.success && response.keywords) {
            setSuummaryData(response.keywords);
        } else {
            setSuummaryData();
        }
    };

    //analyzed summary data
    useEffect(() => {
        if (summaryData && summaryData.length > 0) {
            //common checklist items
            let tempChecklistItems = summaryData[0].messages.filter(
                (x) => x.type === "Checklist" && !x.field.toLowerCase().startsWith("keyword"),
            );
            setSummaryChecklistItems(tempChecklistItems);

            //common competition items
            let tempCompetitionItems = summaryData[0].messages.filter(
                (x) => x.type === "Competition" && !x.field.toLowerCase().startsWith("keyword"),
            );
            setSummaryCompetitionItems(tempCompetitionItems);

            if (selectedKeyword) {
                let kwAnalyzedData = summaryData.find((x) => x.keyword.trim() === selectedKeyword.trim());

                if (kwAnalyzedData && kwAnalyzedData.messages) {
                    let tempChecklistItemsByKeyword = kwAnalyzedData.messages.filter(
                        (x) => x.type === "Checklist" && x.field.toLowerCase().startsWith("keyword"),
                    );
                    setSummaryChecklistItemsByKeyword(tempChecklistItemsByKeyword);

                    let tempCompetitionItemsByKeyword = kwAnalyzedData.messages.filter(
                        (x) => x.type === "Competition" && x.field.toLowerCase().startsWith("keyword"),
                    );
                    setSummaryCompetitionItemsByKeyword(tempCompetitionItemsByKeyword);
                }
            }
        }
    }, [summaryData]);

    const getCompetitorsData = (gridResponseData) => {
        if (gridResponseData && gridResponseData.gridResponse && gridResponseData.gridResponse.data) {
            let tempCompetitorsDataForAllKeywords = [];
            let tempBusinessGridAverageData = [];

            gridResponseData.gridResponse.data.forEach((keywordGridData) => {
                let tempCompetitorsData = [];
                let tempBusinessPositionTotal = 0;

                //we need to attach opposite rankings in order to find most top rankings
                //i.e for ranking 1 we set 21, for 2 is 20..... for 21 is 0, so it's (21-position)
                if (keywordGridData && keywordGridData.points) {
                    keywordGridData.points.forEach((point) => {
                        if (point.results && point.results.length) {
                            //calculate average grid ranking for business
                            let businessItem = point.results.find((x) => x.place_id === gridResponseData.googlePlaceId);
                            if (businessItem) {
                                tempBusinessPositionTotal += businessItem.position;
                            } else {
                                tempBusinessPositionTotal += 21;
                            }

                            //first get all distinct competitors
                            point.results.forEach((pointResult) => {
                                //skip current company results
                                if (
                                    pointResult.place_id !== gridResponseData.googlePlaceId &&
                                    !tempCompetitorsData.some((comp) => comp.place_id === pointResult.place_id)
                                ) {
                                    pointResult.top3Count = 0;
                                    pointResult.positionTotal = 0;
                                    pointResult.reviewsCount = 0;
                                    pointResult.reviewRating = 0;
                                    tempCompetitorsData.push(pointResult);
                                }
                            });
                        }
                    });

                    //get top3 and total sum of position rankings for each competitor
                    tempCompetitorsData.forEach((comp) => {
                        keywordGridData.points.forEach((point) => {
                            if (point.results && point.results.length) {
                                let compPointResult = point.results.find((x) => x.place_id === comp.place_id);

                                let rankingPosition = compPointResult ? compPointResult.position : 21;

                                comp.positionTotal += rankingPosition;

                                if (rankingPosition > 0 && rankingPosition < 4) {
                                    comp.top3Count++;
                                }

                                if (compPointResult) {
                                    comp.reviewsCount = compPointResult.reviewsCount;
                                    comp.reviewRating = compPointResult.reviewRating;
                                }
                            }
                        });
                    });
                }

                let pointsNumber = keywordGridData.points.length;

                tempBusinessGridAverageData.push({
                    keyword: keywordGridData.keyword.trim(),
                    average: parseFloat(tempBusinessPositionTotal / pointsNumber).toFixed(1),
                });
                setBusinessGridAverageData(tempBusinessGridAverageData);

                //calculate average ranking
                tempCompetitorsData.forEach((comp) => {
                    comp.average = parseFloat(comp.positionTotal / pointsNumber).toFixed(1);
                });
                tempCompetitorsData = tempCompetitorsData.sort((a, b) => b.top3Count - a.top3Count);

                tempCompetitorsDataForAllKeywords.push({
                    keyword: keywordGridData.keyword.trim(),
                    competitorsData: tempCompetitorsData,
                });

                //set states for current keyword
                if (selectedKeyword && keywordGridData.keyword.trim() === selectedKeyword.trim()) {
                    setCompetitorsData(tempCompetitorsData);

                    let tempCompetitorsDataCopyString = "";

                    tempCompetitorsData.forEach((competitor) => {
                        if (competitor.top3Count && competitor.top3Count > 0) {
                            tempCompetitorsDataCopyString += `${competitor.title} (${competitor.top3Count}), ${competitor.place_id}, ${competitor.data_cid}, ${competitor.website}\r\n`;
                        }
                    });

                    setCompetitorsDataForCopy(tempCompetitorsDataCopyString);
                }
            });

            setCompetitorsDataForAllKeywords(tempCompetitorsDataForAllKeywords);

            //set business grid average by keyword
            if (selectedKeyword && tempBusinessGridAverageData && tempBusinessGridAverageData.length) {
                let tempBusinessGridAverageDataByKeyword = tempBusinessGridAverageData.find(
                    (x) => x.keyword.trim() === selectedKeyword.trim(),
                );
                if (tempBusinessGridAverageDataByKeyword) {
                    setBusinessGridAverageDataByKeyword(tempBusinessGridAverageDataByKeyword.average);
                }
            }
        }
    };

    const handleCopyCompetitorsData = () => {
        copyToClipboard(competitorsDataForCopy);
        toast.success("Copied to clipboard!");
    };

    const toggleCompetitorsPanel = () => {
        setShowCompetitorsPanel(!showCompetitorsPanel);

        if (showCompetitorsPanel) {
            setSelectedCompetitorOnMap();
        }
    };

    const handleSelectCompetitorOnMap = (competitor) => {
        setSelectedCompetitorOnMap(competitor);
    };

    const printJsonNodeValue = (dataIndex, setting) => {
        let output = "";

        let propName = setting.propName;
        let printPropName = setting.printPropName;
        let label = setting.label;
        let shouldTruncate = setting.shouldTruncate;
        let shouldHighlightText = setting.highlightText;

        if (auditKeywordData) {
            if (propName === "socialProfiles") {
                printSocialProfilesList(dataIndex);
                return;
            } else if (propName === "totalPhotos") {
                //don't open print dialog
                return;
            } else if (printPropName) {
                if (printPropName === "reviews") {
                    printReviewsList(dataIndex, "total", shouldHighlightText);
                    return;
                } else if (printPropName === "reviews.last20") {
                    printReviewsList(dataIndex, "last20", null, shouldHighlightText);
                    return;
                } else if (printPropName === "workTime") {
                    printWorkHours(dataIndex);
                    return;
                } else if (printPropName === "posts") {
                    printPostsList(dataIndex, shouldHighlightText);
                    return;
                } else if (printPropName === "qa") {
                    printQAList(dataIndex, shouldHighlightText);
                    return;
                } else if (
                    printPropName.indexOf("citations") > -1 ||
                    printPropName.indexOf("powerCitations") > -1 ||
                    printPropName.indexOf("powerContent") > -1 ||
                    printPropName.indexOf("indexedPages") > -1
                ) {
                    printCitationsList(dataIndex, printPropName, shouldHighlightText);
                    return;
                }
            }

            let foundNodeValue;
            let prinPropNameArgs = [];

            if (printPropName) {
                prinPropNameArgs = printPropName.indexOf(".") > -1 ? printPropName.split(".") : [printPropName];
            }

            if (prinPropNameArgs && prinPropNameArgs.length === 1) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]];
            } else if (prinPropNameArgs && prinPropNameArgs.length === 2) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
            } else if (prinPropNameArgs && prinPropNameArgs.length === 3) {
                foundNodeValue = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]][prinPropNameArgs[2]];
            }

            if (label) {
                output += `<h4 class="json-output-title mb-3">${label}</h4>`;
            }

            if (foundNodeValue) {
                if (Array.isArray(foundNodeValue)) {
                    foundNodeValue.map((value, index) => {
                        if (typeof value === "object") {
                            output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';
                            output += outputObjectAsHtml(value, index, 0, shouldTruncate);
                            output += "</div>";
                        } else {
                            output += outputValueAsHtml(value, index, shouldTruncate, shouldHighlightText);
                        }
                    });
                } else if (typeof foundNodeValue === "object") {
                    output += outputObjectAsHtml(foundNodeValue, null, 0, shouldTruncate);
                } else {
                    output += outputValueAsHtml(foundNodeValue, null, shouldTruncate, shouldHighlightText);
                }
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const outputObjectAsHtml = (objectValue, arrayIndex = null, nestingLevel = 0, shouldTruncate = true) => {
        let output = "";

        Object.keys(objectValue).map((key, objectIndex) => {
            let parsedItemValue;

            if (objectValue[key]) {
                if (typeof objectValue[key] === "object") {
                    output += outputObjectAsHtml(objectValue[key], null, nestingLevel++, shouldTruncate);
                } else {
                    parsedItemValue = objectValue[key];
                }

                if (parsedItemValue === true) {
                    parsedItemValue = "Yes";
                } else if (parsedItemValue === false) {
                    parsedItemValue = "No";
                }

                let textTruncate = shouldTruncate ? "text-truncate" : "";

                output += `<div class="col-12 json-output-object-item" key="${objectIndex}">`;
                output += `<label class="form-label json-output-object-item-label" title="${key}"><strong>${
                    arrayIndex !== null && objectIndex === 0 ? `<span>${arrayIndex + 1}. </span>` : ""
                }<span>${key}:</span></strong></label>`;

                if (typeof parsedItemValue === "string") {
                    if (parsedItemValue.indexOf("https://") > -1 || parsedItemValue.indexOf("http://") > -1) {
                        output += `<a class="btn btn-link p-0 json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" target="_blank" href="${parsedItemValue}">${parsedItemValue}</a>`;
                    } else {
                        output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
                    }
                } else {
                    if (typeof parsedItemValue === "object") {
                        output += `<div class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}" dangerouslySetInnerHTML="${parsedItemValue}"></div>`;
                    } else {
                        output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${parsedItemValue}">${parsedItemValue}</label>`;
                    }
                }

                output += `</div>`;
            }
        });

        return output;
    };

    const outputValueAsHtml = (value, arrayIndex = null, shouldTruncate = true, shouldHighlightText = false) => {
        let output = "";
        let ordinal = arrayIndex !== null ? `<span>${arrayIndex + 1}. </span>` : "";
        let textTruncate = shouldTruncate ? "text-truncate" : "";
        let titleValue = value;

        if (shouldHighlightText && selectedKeyword) {
            value = getHighlightedText(value, selectedKeyword);
        }

        if (typeof value === "string") {
            if (value.indexOf("https://") > -1 || value.indexOf("http://") > -1) {
                output += `<a class="btn btn-link py-0 json-output-object-item-value ${textTruncate}" title="${titleValue}" target="_blank" href="${value}">${ordinal}${value}</a>`;
            } else {
                output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
            }
        } else {
            output += `<label class="form-label json-output-object-item-value ${textTruncate}" title="${titleValue}">${ordinal}${value}</label>`;
        }

        return output;
    };

    const printReviewsList = (dataIndex, reviewsType, subType = null, shouldHighlightText = false) => {
        let output = "";

        let reviewsTitle = "Reviews";

        switch (reviewsType) {
            case "last30Days":
                reviewsTitle = "Reviews in the last 30 days";
                break;
            case "last20":
                reviewsTitle = "Last 20 Reviews";
                break;
            case "mostRelevant":
                reviewsTitle = "Most Relevant Reviews";
                break;
            case "total":
                reviewsTitle = "Reviews";
                break;
        }

        output += `<h4 class="json-output-title mb-3">${reviewsTitle}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex] && auditKeywordData[dataIndex].reviews) {
            let reviews;

            if (reviewsType === "total") {
                //merge last 20. last 30 days and most relevant reviews
                let reviewsLast30Days = [];
                let reviewsLast20 = [];
                let reviewsMostRelevant = [];

                if (auditKeywordData[dataIndex].reviews.last30Days && auditKeywordData[dataIndex].reviews.last30Days.results) {
                    reviewsLast30Days = auditKeywordData[dataIndex].reviews.last30Days.results;
                }

                if (auditKeywordData[dataIndex].reviews.last20 && auditKeywordData[dataIndex].reviews.last20.results) {
                    reviewsLast20 = auditKeywordData[dataIndex].reviews.last20.results;
                }

                if (auditKeywordData[dataIndex].reviews.mostRelevant && auditKeywordData[dataIndex].reviews.mostRelevant.results) {
                    reviewsMostRelevant = auditKeywordData[dataIndex].reviews.mostRelevant.results;
                }

                let tempMergedReviews = reviewsLast30Days.concat(
                    reviewsLast20.filter((item2) => !reviewsLast30Days.some((item1) => item1.reviewId === item2.reviewId)),
                );

                reviews = tempMergedReviews.concat(
                    reviewsMostRelevant.filter((item2) => !tempMergedReviews.some((item1) => item1.reviewId === item2.reviewId)),
                );
            } else {
                reviews = auditKeywordData[dataIndex].reviews[reviewsType].results;
            }

            if (reviews && reviews.length > 0) {
                //filter by subtype
                if (subType) {
                    if (reviewsType === "last30Days") {
                        switch (subType) {
                            case "last30HaveReplies":
                                reviews = reviews.filter((x) => x.answer !== null);
                                break;
                            case "last30DoNotHaveReplies":
                                reviews = reviews.filter((x) => x.answer === null);
                                break;
                            case "last30LocalGuideReviews":
                                reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
                                break;
                            case "last30NegativeReviews":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
                                break;
                            case "last30NegativeReviewsHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer !== null);
                            case "last30NegativeReviewsDoNotHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer === null);
                                break;
                        }
                    } else if (reviewsType === "last20") {
                        switch (subType) {
                            case "last20HaveReplies":
                                reviews = reviews.filter((x) => x.answer !== null);
                                break;
                            case "last20DoNotHaveReplies":
                                reviews = reviews.filter((x) => x.answer === null);
                                break;
                            case "last20LocalGuideReviews":
                                reviews = reviews.filter((x) => x.user !== null && x.user.localGuide === true);
                                break;
                            case "last20NegativeReviews":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3);
                                break;
                            case "last20NegativeReviewsHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer !== null);
                            case "last20NegativeReviewsDoNotHaveReplies":
                                reviews = reviews.filter((x) => x.rating !== null && x.rating <= 3 && x.answer === null);
                                break;
                        }
                    }
                }

                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    reviews = reviews.filter((review) => {
                        let reviewText = review.text || review.snippet;

                        return reviewText ? reviewText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                reviews.map((review, index) => {
                    if (typeof review === "object") {
                        output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                        //user
                        if (review.user && review.user.name) {
                            output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${
                                review.user.name
                            }"><strong><span>${index + 1}. </span></strong>${review.user.name}`;

                            if (review.user.localGuide === true) {
                                output += `<span class="ms-3">(local guide)</span>`;
                            }
                            output += "</div>";
                        }

                        //rating
                        if (review.rating && parseInt(review.rating)) {
                            let ratingStarsHtml = "";
                            let rating = parseInt(review.rating);
                            for (let i = 0; i < rating; i++) {
                                ratingStarsHtml += `<i class="fa-solid fa-star me-1"></i>`;
                            }

                            if (rating < 5) {
                                for (let i = rating; i < 5; i++) {
                                    ratingStarsHtml += `<i class="fa-regular fa-star text-muted opacity-50 me-1"></i>`;
                                }
                            }

                            output += `<div class="form-label json-output-object-item-value ${truncateText} small-size mb-2">${ratingStarsHtml}`;

                            //date
                            if (review.lastEditOfDate) {
                                output += `<span class="ms-3">${`${moment(review.lastEditOfDate).format("DD/MM/YYYY")} (${
                                    review.dateString
                                })`}</span>`;
                            }

                            output += `</div>`;
                        }

                        //text
                        let reviewText = review.text || review.snippet;
                        let reviewTextForTitle = reviewText;
                        if (reviewText) {
                            if (shouldHighlightText && selectedKeyword) {
                                reviewText = getHighlightedText(reviewText, selectedKeyword);
                            }

                            output += `<div class="json-output-object-item">`;
                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${reviewTextForTitle}">${reviewText}</label>`;
                            output += "</div>";
                        }

                        //answer
                        if (review.answer) {
                            let answerText = review.answer.text || review.answer.text;
                            let answerTextForTitle = answerText;

                            if (shouldHighlightText && selectedKeyword) {
                                answerText = getHighlightedText(answerText, selectedKeyword);
                            }

                            output += `<div class="json-output-object-item">`;
                            output += '<div class="review-answer border-start">';
                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100"><strong>Response:</strong>`;

                            //date
                            if (review.answer.lastEditOfAnswerDate) {
                                output += `<span class="ms-3 small-size">${`${moment(review.answer.lastEditOfAnswerDate).format(
                                    "DD/MM/YYYY",
                                )} (${review.answer.answerDateString})`}</span>`;
                            }
                            output += "</label>";

                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${answerTextForTitle}">${answerText}</label>`;
                            output += "</div>";
                            output += "</div>";
                        }

                        output += "</div>";
                    }
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printSocialProfilesList = (dataIndex) => {
        let output = "";

        let title = "Social Profiles";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].profile &&
            auditKeywordData[dataIndex].profile.socialProfiles
        ) {
            let items = auditKeywordData[dataIndex].profile.socialProfiles;

            if (items && items.length > 0) {
                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    //name
                    if (item.name) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<span>${index + 1}. </span>${item.name}`;
                        output += "</div>";
                    }

                    //link
                    if (item.link) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printPostsList = (dataIndex, shouldHighlightText = false) => {
        let output = "";

        let title = "Posts";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].posts &&
            auditKeywordData[dataIndex].posts.results
        ) {
            let items = auditKeywordData[dataIndex].posts.results;

            if (items && items.length > 0) {
                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    items = items.filter((item) => {
                        return item.postText ? item.postText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    // //author
                    // if (item.author) {
                    // 	output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                    // 	output += `<span>${index + 1}. </span>${item.author}`;
                    // 	output += '</div>';
                    // }

                    //date
                    if (item.postDateValue) {
                        output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                        output += `<span>${index + 1}. </span><span>${moment(item.postDateValue).format("DD/MM/YYYY")}`;
                        output += "</div>";
                    }

                    //text
                    if (item.postText) {
                        let textFortitle = item.postText;

                        if (shouldHighlightText && selectedKeyword) {
                            item.postText = getHighlightedText(item.postText, selectedKeyword);
                        }

                        output += `<div class="form-label json-output-object-item-value ${truncateText}">`;
                        output += `<label class="json-output-object-item-value ${truncateText}" title="${textFortitle}">${item.postText}</label>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printQAList = (dataIndex, shouldHighlightText = false) => {
        let output = "";

        let title = "Questions & Answers";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex] && auditKeywordData[dataIndex].qa && auditKeywordData[dataIndex].qa.results) {
            let items = auditKeywordData[dataIndex].qa.results;

            if (items && items.length > 0) {
                //if it is keyword relevance section, filter by keyword
                if (shouldHighlightText && selectedKeyword) {
                    items = items.filter((item) => {
                        return item.questionText ? item.questionText.toLowerCase().indexOf(selectedKeyword.toLowerCase()) > -1 : false;
                    });
                }

                let truncateText = shouldHighlightText && selectedKeyword ? "" : "text-truncate";

                items.map((item, index) => {
                    output += '<div class="json-output-array-item mb-2 py-2 border-bottom" key="' + index + '">';

                    //user
                    if (item.profileName) {
                        output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${
                            item.profileName
                        }"><span>${index + 1}. </span>${item.profileName}`;

                        output += "</div>";
                    }

                    //date
                    if (item.dateCreated) {
                        output += `<div class="form-label json-output-object-item-value small-size ${truncateText} ms-3 mb-1">`;
                        output += `<span>${moment(item.dateCreated).format("DD/MM/YYYY")}</span>`;
                        output += `<span class="ms-3">(${item.timeAgo})</span>`;
                        output += "</div>";
                    }

                    //text
                    if (item.questionText) {
                        let textForTitle = item.questionText;

                        if (shouldHighlightText && selectedKeyword) {
                            item.questionText = getHighlightedText(item.questionText, selectedKeyword);
                        }

                        output += `<div class="json-output-object-item">`;
                        output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${textForTitle}">${item.questionText}</label>`;
                        output += "</div>";
                    }

                    //answers
                    if (item.items) {
                        output += '<div class="qa-answers-wrapper border-start">';

                        item.items.forEach((answer) => {
                            //user
                            if (answer.profileName) {
                                output += `<div class="form-label json-output-object-item-value ${truncateText}" title="${answer.profileName}">${answer.profileName}</div>`;
                            }

                            if (answer.timestamp) {
                                output += `<div class="form-label json-output-object-item-value small-size ${truncateText} mb-1">`;
                                output += `<span>${moment(answer.timestamp).format("DD/MM/YYYY")}</span>`;
                                output += `<span class="ms-3">(${answer.timeAgo})</span>`;
                                output += "</div>";
                            }

                            let textForTitle = answer.answerText;

                            if (shouldHighlightText && selectedKeyword) {
                                answer.answerText = getHighlightedText(answer.answerText, selectedKeyword);
                            }

                            output += `<label class="form-label json-output-object-item-value ${truncateText} w-100" title="${textForTitle}">${answer.answerText}</label>`;
                            output += "</div>";
                            output += "</div>";
                        });

                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printWorkHours = (dataIndex) => {
        let output = "";

        let title = "Business Hours";
        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (
            auditKeywordData &&
            auditKeywordData[dataIndex] &&
            auditKeywordData[dataIndex].profile &&
            auditKeywordData[dataIndex].profile.workTime &&
            auditKeywordData[dataIndex].profile.workTime.data &&
            auditKeywordData[dataIndex].profile.workTime.data.timetable
        ) {
            let days = auditKeywordData[dataIndex].profile.workTime.data.timetable;

            if (days) {
                Object.keys(days).map((key, index) => {
                    let hoursStr = "";
                    output += `<div class="row json-output-array-item mb-1" key="${index}">`;
                    output += `<label class="form-label json-output-object-item-label">${capitalize(key)}:</label>`;

                    if (days[key] && Array.isArray(days[key]) && days[key].length > 0) {
                        let dayObj = days[key][0];

                        if (dayObj) {
                            if (dayObj.open && dayObj.open.hour !== null) {
                                let openStr = dayObj.open.hour;

                                if (dayObj.open.minute !== null) {
                                    openStr += ":" + (parseInt(dayObj.open.minute) === 0 ? "00" : dayObj.open.minute);
                                }

                                if (openStr) {
                                    //hoursStr += moment(openStr, [ 'h:mm A' ]).format('HH:mm');
                                    hoursStr += moment(openStr, "HH:mm").format("h:mm A");
                                }
                            }

                            if (dayObj.close && dayObj.close.hour !== null) {
                                let closeStr = dayObj.close.hour;

                                if (dayObj.close.minute !== null) {
                                    closeStr += ":" + (parseInt(dayObj.close.minute) === 0 ? "00" : dayObj.close.minute);
                                }

                                if (closeStr) {
                                    hoursStr += " - " + moment(closeStr, "HH:mm").format("h:mm A");
                                }
                            }
                        }
                    } else {
                        hoursStr = "Closed";
                    }

                    output += `<label class="form-label json-output-object-item-value w-auto">${hoursStr}</label>`;
                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const printCitationsList = (dataIndex, printPropName, shouldHighlightText = false) => {
        let output = "";

        let title = "";
        let prinPropNameArgs = [];

        if (printPropName) {
            prinPropNameArgs = printPropName.indexOf(".") > -1 ? printPropName.split(".") : [printPropName];

            if (printPropName.indexOf("powerContent") > -1) {
                title = "Power Content";
            } else if (printPropName.indexOf("powerCitations") > -1) {
                title = "Power Citations";
            } else if (printPropName.indexOf("citations") > -1) {
                title = "Citations";
            } else if (printPropName.indexOf("indexedPages") > -1) {
                title = "Indexed Pages";
            }
        }

        output += `<h4 class="json-output-title mb-3">${title}</h4>`;

        if (auditKeywordData && auditKeywordData[dataIndex]) {
            let results;

            if (prinPropNameArgs && prinPropNameArgs.length === 2) {
                if (prinPropNameArgs[1] === "results") {
                    results = auditKeywordData[dataIndex][prinPropNameArgs[0]][prinPropNameArgs[1]];
                } else {
                    let items = auditKeywordData[dataIndex][prinPropNameArgs[0]].find(
                        (x) => x.website.indexOf(prinPropNameArgs[1].replace("__", ".").replace("___", "/")) > -1,
                    );

                    if (items && items.results) {
                        results = items.results;
                    }
                }
            }

            if (results && results.length > 0) {
                results.map((item, index) => {
                    output += `<div class="json-output-array-item mb-2 py-2 border-bottom" key="${index}">`;

                    //title
                    if (item.title) {
                        if (shouldHighlightText && selectedKeyword) {
                            item.title = getHighlightedText(item.title, selectedKeyword);
                        }

                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<span>${index + 1}. </span>${item.title}`;
                        output += "</div>";
                    }

                    //link
                    if (item.link) {
                        output += `<div class="form-label json-output-object-item-value text-truncate">`;
                        output += `<a class="btn btn-link p-0 json-output-object-item-value text-truncate" title="${item.link}" href="${item.link}" target="_blank">${item.link}</a>`;
                        output += "</div>";
                    }

                    output += "</div>";
                });
            } else {
                output += '<label class="form-label json-output-object-item-value">No data</label>';
            }
        } else {
            output += '<label class="form-label json-output-object-item-value">No data</label>';
        }

        setJsonOutput(output);
        toggleJsonOutputDialog();

        return output;
    };

    const toggleJsonOutputDialog = async (e) => {
        setShowJsonOutputDialog(!showJsonOutputDialog);

        if (showJsonOutputDialog) {
            setJsonOutput();
        }

        if (e) e.preventDefault();
    };

    const handleCheckboxSelect = (e) => {
        let type = e.target.type;
        let name = e.target.name;
        let value = e.target.value;
        let checked = e.target.checked;

        let tempAuditFormData = { ...auditFormData };

        if (type === "checkbox") {
            if (name.indexOf("isSelectedAuditPowerCitations") > -1) {
                if (!tempAuditFormData.isSelectedAuditPowerCitationsItems) {
                    tempAuditFormData.isSelectedAuditPowerCitationsItems = [];
                }

                let websiteSlug = name.replace("isSelectedAuditPowerCitations", "");

                if (checked) {
                    if (!tempAuditFormData.isSelectedAuditPowerCitationsItems.includes(websiteSlug)) {
                        tempAuditFormData.isSelectedAuditPowerCitationsItems.push(websiteSlug);
                    }
                } else {
                    tempAuditFormData.isSelectedAuditPowerCitationsItems = tempAuditFormData.isSelectedAuditPowerCitationsItems.filter(
                        (x) => x !== websiteSlug,
                    );
                }
            } else if (name.indexOf("isSelectedAuditPowerContent") > -1) {
                if (!tempAuditFormData.isSelectedAuditPowerContentItems) {
                    tempAuditFormData.isSelectedAuditPowerContentItems = [];
                }

                let websiteSlug = name.replace("isSelectedAuditPowerContent", "");

                if (checked) {
                    if (!tempAuditFormData.isSelectedAuditPowerContentItems.includes(websiteSlug)) {
                        tempAuditFormData.isSelectedAuditPowerContentItems.push(websiteSlug);
                    }
                } else {
                    tempAuditFormData.isSelectedAuditPowerContentItems = tempAuditFormData.isSelectedAuditPowerContentItems.filter(
                        (x) => x !== websiteSlug,
                    );
                }
            } else {
                if (checked) {
                    tempAuditFormData[name] = checked;
                } else {
                    //delete tempAuditFormData[name];
                    tempAuditFormData[name] = checked;
                }
            }
        } else {
            tempAuditFormData[name] = value;
        }

        setAuditFormData(tempAuditFormData);
    };

    const checkAllItems = () => {
        let tempAuditFormData = {};
        let chkElements = document.querySelectorAll(`[name*="isSelectedAudit"]`);

        if (chkElements) {
            chkElements.forEach((chk) => {
                tempAuditFormData[chk.name] = true;
            });
        }
        setAuditFormData(tempAuditFormData);
    };

    const uncheckAllItems = () => {
        let tempAuditFormData = {};
        let chkElements = document.querySelectorAll(`[name*="isSelectedAudit"]`);

        if (chkElements) {
            chkElements.forEach((chk) => {
                tempAuditFormData[chk.name] = false;
            });
        }

        setAuditFormData(tempAuditFormData);
    };

    const checkUncheckPowerCitationsItems = (value) => {
        let tempAuditFormData = { ...auditFormData };

        tempAuditFormData.isSelectedAuditPowerCitationsItems = [];
        tempAuditFormData.isSelectedAuditPowerCitations = value;

        if (value) {
            let chkElements = document.querySelectorAll(`[name*="isSelectedAuditPowerCitations"]`);

            if (chkElements) {
                chkElements.forEach((chk) => {
                    if (chk.name !== "isSelectedAuditPowerCitations") {
                        tempAuditFormData.isSelectedAuditPowerCitationsItems.push(chk.name.replace("isSelectedAuditPowerCitations", ""));
                    }
                });
            }
        }

        setAuditFormData(tempAuditFormData);
    };

    const checkUncheckPowerContentItems = (value) => {
        let tempAuditFormData = { ...auditFormData };

        tempAuditFormData.isSelectedAuditPowerContentItems = [];
        tempAuditFormData.isSelectedAuditPowerContent = value;

        if (value) {
            let chkElements = document.querySelectorAll(`[name*="isSelectedAuditPowerContent"]`);

            if (chkElements) {
                chkElements.forEach((chk) => {
                    if (chk.name !== "isSelectedAuditPowerContent") {
                        tempAuditFormData.isSelectedAuditPowerContentItems.push(chk.name.replace("isSelectedAuditPowerContent", ""));
                    }
                });
            }
        }

        console.log(tempAuditFormData.isSelectedAuditPowerContentItems);

        setAuditFormData(tempAuditFormData);
    };

    return (
        <div className="app-container">
            <div className="grid-tool-left-container">
                {appVersion && (
                    <div className="app-left-nav-dev-version bg-danger">
                        <h5>{`${appVersion.toUpperCase()} VERSION`}</h5>
                    </div>
                )}

                {showGridReport ? (
                    <div className="p-3 task-settings-wrapper">
                        {companyData && companyData.name && (
                            <div className="company-name text-truncate">
                                <span>{companyData.name}</span>
                            </div>
                        )}

                        {isLoading ? (
                            <div className="text-center">
                                <Spinner />
                            </div>
                        ) : (
                            <Fragment>
                                {dateCreated && (
                                    <div className="created-date mb-3">
                                        <Fragment>
                                            <span>Date Created:</span>
                                            <span className="ms-2">{moment(dateCreated).format("MM/DD/YYYY [@] hh:mm A [EST]")}</span>
                                        </Fragment>
                                    </div>
                                )}

                                {!isEdit && (
                                    <div className="mb-4">
                                        <a className="btn btn-link p-0 text-decoration-underline" href={`/reports/${reportId}/edit`}>
                                            Change Keywords or Grid Size
                                        </a>
                                    </div>
                                )}

                                <div>
                                    {keywordsArray &&
                                        keywordsArray.length > 0 &&
                                        keywordsArray.map((keywordName, index) => (
                                            <div key={index} className="mb-2">
                                                <button
                                                    className={`btn btn${
                                                        selectedKeyword && selectedKeyword === keywordName ? "" : "-outline"
                                                    }-primary btn-lg w-100 `}
                                                    onClick={() => handleSelectKeyword(keywordName)}
                                                    disabled={isGenerating || isLoadingMap}
                                                >
                                                    {keywordName}
                                                </button>
                                            </div>
                                        ))}
                                </div>
                            </Fragment>
                        )}
                    </div>
                ) : (
                    <Fragment>
                        {isLoading ? (
                            <div className="text-center">
                                <Spinner />
                            </div>
                        ) : (
                            <div className="p-3 task-settings-wrapper">
                                {companyData && companyData.name && (
                                    <div className="company-name text-truncate">
                                        <span>{companyData.name}</span>
                                    </div>
                                )}

                                <form className="mt-3">
                                    <div className="col-12 mb-3">
                                        <label className="form-label">Service Area Radius</label>
                                        <div className="row">
                                            <div className="col-9 pe-0">
                                                <input
                                                    type="range"
                                                    name="areaRadius"
                                                    className="form-range"
                                                    value={areaRadius || ""}
                                                    onChange={handleChange}
                                                    min={1}
                                                    max={15}
                                                    step={0.5}
                                                    disabled={isGenerating || isLoadingMap}
                                                />
                                            </div>
                                            <div className="col-3 text-end">
                                                <span className="area-radius-value">{`${areaRadius || ""} miles`}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label">Keywords: (one per line, up to 5 terms)</label>
                                        <textarea
                                            name="keywords"
                                            className="form-control"
                                            value={keywords || ""}
                                            onChange={handleChange}
                                            disabled={isGenerating || isLoadingMap}
                                            rows={5}
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <label className="form-label">Industry Category:</label>
                                        <select
                                            name="industryCategoryIdForm"
                                            className="form-select"
                                            onChange={(e) => setSelectedIndustryCategoryIdForm(e.target.value)}
                                            value={selectedIndustryCategoryIdForm || ""}
                                        >
                                            {/* <option value="">- Select Industry -</option> */}
                                            {adminSettings && adminSettings.industryCategories && (
                                                <Fragment>
                                                    {adminSettings.industryCategories.map((category, index) => (
                                                        <option value={category.categoryGuid} key={index}>
                                                            {category.categoryName}
                                                        </option>
                                                    ))}
                                                </Fragment>
                                            )}
                                        </select>
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input
                                            id="alsoGenerateAuditReport"
                                            name="alsoGenerateAuditReport"
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={alsoGenerateAuditReport}
                                            onChange={(e) => setAlsoGenerateAuditReport(e.target.checked)}
                                            disabled={isGenerating || isLoadingMap}
                                        />
                                        <label htmlFor="alsoGenerateAuditReport" className="form-label ms-2">
                                            Generate Audit Report Also?
                                        </label>
                                    </div>
                                    <div className="col-12 text-center">
                                        {companyTaskQueues && companyTaskQueues.length > 0 ? (
                                            <span className="text-primary border border-primary rounded p-2">{`There is already ${companyTaskQueues[0].status} report.`}</span>
                                        ) : (
                                            <button
                                                className="btn btn-primary"
                                                onClick={(e) => generateGridReportNEW(e)}
                                                disabled={isGenerating || isLoadingMap}
                                            >
                                                {isGenerating ? (
                                                    <Fragment>
                                                        <span className="spinner-border m-0 me-2" />
                                                        <span>Continue</span>
                                                    </Fragment>
                                                ) : (
                                                    <span>Continue</span>
                                                )}
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        )}
                    </Fragment>
                )}

                <div className="grid-tool-buttons-container">
                    {reportTasks && reportTasks.length > 0 && !isLoading && (
                        <div>
                            <button
                                className="btn btn-link p-0"
                                onClick={() => getReportShareLink()}
                                disabled={isGenerating || isLoadingMap}
                            >
                                <span>
                                    {showShareLinkCopiedMessage ? (
                                        <span className="bg-success text-white py-1 px-3 rounded">Copied!</span>
                                    ) : (
                                        "Get Share Link"
                                    )}
                                </span>
                            </button>
                            <span className="mx-2">|</span>
                            <button className="btn btn-link p-0" onClick={exportMapAsImage} disabled={isGenerating || isLoadingMap}>
                                Export As Image
                            </button>
                        </div>
                    )}

                    <div className="mt-3">
                        <Link className="btn btn-outline-primary" to="/reports">
                            <i className="fa-solid fa-arrow-left-long me-2" />
                            Reports
                        </Link>
                    </div>
                </div>
            </div>

            <div className="main-content-inner-container grid-tool-content-container p-2 rounded-0">
                <div className="map-wrapper position-relative" ref={gridMapContainerRef}>
                    <Fragment>
                        {showGridReport ? (
                            <Fragment>
                                {(!gridData || isGenerating || isLoadingMap) && (
                                    <div className="loading-map">
                                        <Spinner />
                                        {loadingMessage && <div className="loading-message">{loadingMessage}</div>}
                                    </div>
                                )}

                                <ul className="nav nav-tabs" id="tabReport" role="tablist">
                                    <li className="nav-item" role="presentation" key="grid-report">
                                        <button
                                            className="nav-link active"
                                            id="grid-report-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#grid-report-tab-pane"
                                            type="button"
                                            role="tab"
                                            aria-controls="grid-report-tab-pane"
                                            aria-selected="true"
                                        >
                                            Grid
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation" key="competitors">
                                        <button
                                            className="nav-link"
                                            id="competitors-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#competitors-tab-pane"
                                            type="button"
                                            role="tab"
                                            aria-controls="competitors-tab-pane"
                                            aria-selected="true"
                                        >
                                            Competitors
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation" key="audit-report">
                                        <button
                                            className="nav-link"
                                            id="audit-report-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#audit-report-tab-pane"
                                            type="button"
                                            role="tab"
                                            aria-controls="audit-report-tab-pane"
                                            aria-selected="true"
                                        >
                                            Audit
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation" key="summary-report">
                                        <button
                                            className="nav-link"
                                            id="summary-report-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#summary-report-tab-pane"
                                            type="button"
                                            role="tab"
                                            aria-controls="summary-report-tab-pane"
                                            aria-selected="true"
                                        >
                                            Summary
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation" key="compare-report">
                                        <button
                                            className="nav-link"
                                            id="compare-report-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#compare-report-tab-pane"
                                            type="button"
                                            role="tab"
                                            aria-controls="compare-report-tab-pane"
                                            aria-selected="true"
                                        >
                                            Compare
                                        </button>
                                    </li>
                                </ul>
                                <div className="tab-content border" id="tabReportContent">
                                    {/* grid */}
                                    <div
                                        className="tab-pane fade show active"
                                        id="grid-report-tab-pane"
                                        role="tabpanel"
                                        aria-labelledby="grid-report-tab"
                                        tabIndex="0"
                                    >
                                        {gridData && (
                                            <Fragment>
                                                <div className="new-item-wrapper">
                                                    <button className="btn btn-primary" onClick={toggleCompetitorsPanel}>
                                                        {`${showCompetitorsPanel ? "Hide" : "Show"} Competitors`}
                                                    </button>
                                                </div>
                                                <div className="grid-map-container">
                                                    <GridMapV5
                                                        key="map-0"
                                                        mapIdValue="report-map-0"
                                                        gridData={gridData}
                                                        placeId={gridData.googlePlaceId}
                                                        isFullHeight={true}
                                                        reportSettings={reportSettings}
                                                        selectedCompetitor={selectedCompetitorOnMap}
                                                    />

                                                    {showCompetitorsPanel && (
                                                        <div className="map-competitors-panel">
                                                            {competitorsData && competitorsData.length > 0 && (
                                                                <Fragment>
                                                                    {competitorsData.map((competitor, index) => (
                                                                        <Fragment key={index}>
                                                                            {competitor.place_id && (
                                                                                <div
                                                                                    className={`competitor-item ${
                                                                                        selectedCompetitorOnMap &&
                                                                                        selectedCompetitorOnMap.place_id ===
                                                                                            competitor.place_id
                                                                                            ? "active"
                                                                                            : ""
                                                                                    }`}
                                                                                    key={index}
                                                                                    onClick={() => handleSelectCompetitorOnMap(competitor)}
                                                                                >
                                                                                    <div className="competitor-name">
                                                                                        {competitor.title || ""}
                                                                                    </div>
                                                                                    <div className="competitor-detail">
                                                                                        <span className="competitor-label">
                                                                                            {competitor.place_id || ""}
                                                                                        </span>
                                                                                    </div>

                                                                                    {competitor.data_cid && (
                                                                                        <div className="competitor-detail">
                                                                                            {/* <span className="competitor-label">Cid:</span> */}
                                                                                            <span className="competitor-label">
                                                                                                {competitor.data_cid}
                                                                                            </span>
                                                                                        </div>
                                                                                    )}

                                                                                    {competitor.website && (
                                                                                        <div className="competitor-detail">
                                                                                            {/* <span className="competitor-label">
																							Website:
																						</span> */}
                                                                                            <span className="competitor-label">
                                                                                                <a
                                                                                                    className="btn btn-link p-0"
                                                                                                    href={`https://${competitor.website}`}
                                                                                                    target="_blank"
                                                                                                >
                                                                                                    {`https://${competitor.website}`}
                                                                                                </a>
                                                                                            </span>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </Fragment>
                                                                    ))}
                                                                </Fragment>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </Fragment>
                                        )}
                                    </div>

                                    {/* competitors */}
                                    <div
                                        className="tab-pane fade"
                                        id="competitors-tab-pane"
                                        role="tabpanel"
                                        aria-labelledby="competitors-tab"
                                        tabIndex="0"
                                    >
                                        <div className="competitors-data-container p-3">
                                            {competitorsData && competitorsData.length > 0 && (
                                                <button className="btn btn-outline-primary mb-3" onClick={handleCopyCompetitorsData}>
                                                    Copy Competitors Data
                                                </button>
                                            )}

                                            {competitorsData && competitorsData.length > 0 && (
                                                <div className="competitors-wrapper">
                                                    {/* add business data first */}
                                                    <div className="competitor-item mb-3">
                                                        <div className="competitor-name">{companyData.name || ""}</div>
                                                        <div className="competitor-detail">
                                                            <span className="competitor-label">Place Id:</span>
                                                            <span className="competitor-value">{companyData.googlePlaceId || ""}</span>
                                                        </div>
                                                        <div className="competitor-detail">
                                                            <span className="competitor-label">Cid:</span>
                                                            <span className="competitor-value">{companyData.googleCid || ""}</span>
                                                        </div>
                                                        <div className="competitor-detail">
                                                            <span className="competitor-label">Website:</span>
                                                            <span className="competitor-value">
                                                                {companyData.website ? (
                                                                    <a
                                                                        className="btn btn-link p-0"
                                                                        href={companyData.website}
                                                                        target="_blank"
                                                                    >
                                                                        {companyData.website}
                                                                    </a>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <hr />

                                                    {competitorsData.map((competitor, index) => (
                                                        <Fragment key={index}>
                                                            {competitor.top3Count ? (
                                                                <div className="competitor-item mb-3">
                                                                    <div className="competitor-name">{competitor.title || ""}</div>
                                                                    <div className="competitor-top3-count">
                                                                        <span className="competitor-label">Top 3 Rankings:</span>
                                                                        <span className="competitor-value">
                                                                            {competitor.top3Count || ""}
                                                                        </span>
                                                                    </div>
                                                                    <div className="competitor-detail">
                                                                        <span className="competitor-label">Place Id:</span>
                                                                        <span className="competitor-value">
                                                                            {competitor.place_id || ""}
                                                                        </span>
                                                                    </div>
                                                                    <div className="competitor-detail">
                                                                        <span className="competitor-label">Cid:</span>
                                                                        <span className="competitor-value">
                                                                            {competitor.data_cid || ""}
                                                                        </span>
                                                                    </div>
                                                                    {competitor.website && (
                                                                        <div className="competitor-detail">
                                                                            <span className="competitor-label">Website:</span>
                                                                            <span className="competitor-value">
                                                                                <a
                                                                                    className="btn btn-link p-0"
                                                                                    href={`https://${competitor.website}`}
                                                                                    target="_blank"
                                                                                >
                                                                                    {`https://${competitor.website}`}
                                                                                </a>
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <Fragment />
                                                            )}
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* audit */}
                                    <div
                                        className="tab-pane fade"
                                        id="audit-report-tab-pane"
                                        role="tabpanel"
                                        aria-labelledby="audit-report-tab"
                                        tabIndex="0"
                                    >
                                        <div className="audit-data-container p-3">
                                            <div className="row align-items-center mb-3">
                                                <div className="col-auto">
                                                    <label className="form-label mb-0">Industry:</label>
                                                </div>
                                                <div className="col-auto">
                                                    <select
                                                        className="form-select"
                                                        onChange={(e) => setSelectedIndustryCategory(e.target.value)}
                                                        value={selectedIndustryCategory || ""}
                                                    >
                                                        <option value="">- Select Industry -</option>
                                                        {adminSettings && adminSettings.industryCategories && (
                                                            <Fragment>
                                                                {adminSettings.industryCategories.map((category, index) => (
                                                                    <option value={category.categoryGuid} key={index}>
                                                                        {category.categoryName}
                                                                    </option>
                                                                ))}
                                                            </Fragment>
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-auto">
                                                    {companyTaskQueues && companyTaskQueues.length > 0 ? (
                                                        <span className="text-primary border border-primary rounded p-2">{`There is already ${companyTaskQueues[0].status} report.`}</span>
                                                    ) : (
                                                        <Fragment>
                                                            {auditFormData &&
                                                            (Object.keys(auditFormData).some((x) => auditFormData[x] === true) ||
                                                                (auditFormData.isSelectedAuditPowerCitationsItems &&
                                                                    auditFormData.isSelectedAuditPowerCitationsItems.length) ||
                                                                (auditFormData.isSelectedAuditPowerContentItems &&
                                                                    auditFormData.isSelectedAuditPowerContentItems.length)) ? (
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={updateAuditData}
                                                                    disabled={isUpdatingAudit}
                                                                >
                                                                    {isUpdatingAudit ? (
                                                                        <Fragment>
                                                                            <span className="spinner-border m-0 me-2" />
                                                                            <span>Updating...</span>
                                                                        </Fragment>
                                                                    ) : (
                                                                        <span>Update Audit Data</span>
                                                                    )}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={() =>
                                                                        generateAuditDataNEW(
                                                                            companyData,
                                                                            selectedIndustryCategory,
                                                                            competitorsDataForAllKeywords,
                                                                            selectedTask.id,
                                                                        )
                                                                    }
                                                                    disabled={isGeneratingAudit}
                                                                >
                                                                    {isGeneratingAudit ? (
                                                                        <Fragment>
                                                                            <span className="spinner-border m-0 me-2" />
                                                                            <span>Generating...</span>
                                                                        </Fragment>
                                                                    ) : (
                                                                        <span>Generate Audit Data</span>
                                                                    )}
                                                                </button>
                                                            )}
                                                        </Fragment>
                                                    )}
                                                </div>
                                                <div className="col-auto task-location-wrapper">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter location"
                                                        value={taskLocation || ""}
                                                        onChange={(e) => setTaskLocation(e.target.value)}
                                                    />
                                                    <button
                                                        className="btn btn-primary ms-2"
                                                        onClick={saveTaskLocation}
                                                        disabled={isUpdatingAudit || isGenerating}
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="audit-table-wrapper border">
                                                {isLoadingAuditData ? (
                                                    <div className="text-center">
                                                        <Spinner />
                                                    </div>
                                                ) : (
                                                    <table className="items-list audit-table table table-responsive">
                                                        <thead>
                                                            <tr>
                                                                <th className="checkbox" scope="col" />
                                                                <th scope="col" className="description">
                                                                    Average Grid Rank:
                                                                </th>
                                                                <th className="business" scope="col">
                                                                    {businessGridAverageDataByKeyword}
                                                                </th>
                                                                <th className="business competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 0 && (
                                                                        <span>{competitorsData[0].average || ""}</span>
                                                                    )}
                                                                </th>
                                                                <th className="business competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 1 && (
                                                                        <span>{competitorsData[1].average || ""}</span>
                                                                    )}
                                                                </th>
                                                                <th className="business competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 2 && (
                                                                        <span>{competitorsData[2].average || ""}</span>
                                                                    )}
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th className="checkbox py-0" scope="col">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        onChange={(e) => {
                                                                            if (e.target.checked) {
                                                                                checkAllItems();
                                                                            } else {
                                                                                setAuditFormData({});
                                                                            }
                                                                        }}
                                                                        title="Check all items to update"
                                                                    />
                                                                </th>
                                                                <th scope="col" className="description py-0">
                                                                    Description:
                                                                </th>
                                                                <th className="business py-0" scope="col">
                                                                    {companyData && companyData.googleBusinessUrl ? (
                                                                        <a
                                                                            className="btn btn-link p-0"
                                                                            href={companyData.googleBusinessUrl}
                                                                            target="_blank"
                                                                            title={companyData.name || ""}
                                                                        >
                                                                            <span>Your Business</span>
                                                                            <i className="fa-solid fa-arrow-up-right-from-square ms-2" />
                                                                        </a>
                                                                    ) : (
                                                                        "Your Business"
                                                                    )}
                                                                </th>
                                                                <th className="business competitor py-0" scope="col">
                                                                    {competitorsData &&
                                                                    competitorsData.length > 0 &&
                                                                    competitorsData[0].data_cid ? (
                                                                        <a
                                                                            className="btn btn-link p-0"
                                                                            href={`https://maps.google.com/?cid=${competitorsData[0].data_cid}`}
                                                                            target="_blank"
                                                                            title={competitorsData[0].title || ""}
                                                                        >
                                                                            <span>Competitor 1</span>
                                                                            <i className="fa-solid fa-arrow-up-right-from-square ms-2" />
                                                                        </a>
                                                                    ) : (
                                                                        "Competitor 1"
                                                                    )}
                                                                </th>
                                                                <th className="business competitor py-0" scope="col">
                                                                    {competitorsData &&
                                                                    competitorsData.length > 1 &&
                                                                    competitorsData[1].data_cid ? (
                                                                        <a
                                                                            className="btn btn-link p-0"
                                                                            href={`https://maps.google.com/?cid=${competitorsData[1].data_cid}`}
                                                                            target="_blank"
                                                                            title={competitorsData[1].title || ""}
                                                                        >
                                                                            <span>Competitor 2</span>
                                                                            <i className="fa-solid fa-arrow-up-right-from-square ms-2" />
                                                                        </a>
                                                                    ) : (
                                                                        "Competitor 2"
                                                                    )}
                                                                </th>
                                                                <th className="business competitor py-0" scope="col">
                                                                    {competitorsData &&
                                                                    competitorsData.length > 2 &&
                                                                    competitorsData[2].data_cid ? (
                                                                        <a
                                                                            className="btn btn-link p-0"
                                                                            href={`https://maps.google.com/?cid=${competitorsData[2].data_cid}`}
                                                                            target="_blank"
                                                                            title={competitorsData[2].title || ""}
                                                                        >
                                                                            <span>Competitor 3</span>
                                                                            <i className="fa-solid fa-arrow-up-right-from-square ms-2" />
                                                                        </a>
                                                                    ) : (
                                                                        "Competitor 3"
                                                                    )}
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th className="checkbox" scope="col" />
                                                                <th scope="col" className="description" />
                                                                <th className="business-name" scope="col">
                                                                    {companyData && <span>{companyData.name || ""}</span>}
                                                                </th>
                                                                <th className="business-name competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 0 && (
                                                                        <span>{competitorsData[0].title || ""}</span>
                                                                    )}
                                                                </th>
                                                                <th className="business-name competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 1 && (
                                                                        <span>{competitorsData[1].title || ""}</span>
                                                                    )}
                                                                </th>
                                                                <th className="business-name competitor" scope="col">
                                                                    {competitorsData && competitorsData.length > 2 && (
                                                                        <span>{competitorsData[2].title || ""}</span>
                                                                    )}
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        {auditKeywordData && auditKeywordData.length > 0 ? (
                                                            <tbody>
                                                                {/* Profile Settings */}
                                                                {settings.map((setting) => (
                                                                    <tr key={setting.label}>
                                                                        <td className="checkbox">
                                                                            {setting.checkboxName && (
                                                                                <input
                                                                                    name={`isSelectedAudit${setting.checkboxName}`}
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        auditFormData[
                                                                                            `isSelectedAudit${setting.checkboxName}`
                                                                                        ]
                                                                                    }
                                                                                    onChange={handleCheckboxSelect}
                                                                                    title="Check to update business profile data"
                                                                                />
                                                                            )}
                                                                        </td>
                                                                        <td className="description">{setting.label}</td>
                                                                        {auditKeywordData.map((business, index) => {
                                                                            let propValue = business[setting.propName];

                                                                            return (
                                                                                <td
                                                                                    key={index}
                                                                                    className={`business ${
                                                                                        business === "business" ? "" : "competitor"
                                                                                    }`}
                                                                                >
                                                                                    {propValue ? (
                                                                                        <Fragment>
                                                                                            {setting.printPropName ? (
                                                                                                <button
                                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                                    onClick={() =>
                                                                                                        printJsonNodeValue(index, setting)
                                                                                                    }
                                                                                                >
                                                                                                    <span className="btn-json-output">
                                                                                                        {isNumber(propValue)
                                                                                                            ? propValue
                                                                                                            : "Yes"}
                                                                                                    </span>
                                                                                                </button>
                                                                                            ) : (
                                                                                                <span className="btn-json-output">
                                                                                                    <span>
                                                                                                        {isNumber(propValue)
                                                                                                            ? propValue
                                                                                                            : "Yes"}
                                                                                                    </span>
                                                                                                </span>
                                                                                            )}
                                                                                        </Fragment>
                                                                                    ) : (
                                                                                        <span className="json-output-no-value">No</span>
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}

                                                                {/* Domain Age */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditDomainAge"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditDomainAge}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update domain WhoIs data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Domain Age</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        return (
                                                                            <td key={index} className="business">
                                                                                {business.domainAge !== null &&
                                                                                business.domainAge !== "" &&
                                                                                business.domainAge !== -1
                                                                                    ? `${business.domainAge} ${
                                                                                          business.domainAge === 1 ? "Year" : "Years"
                                                                                      }`
                                                                                    : ""}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>

                                                                {/* Total Indexed Pages */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditIndexedPages"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditIndexedPages}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website indexed pages data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Total Indexed Pages</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        let printSetting = {
                                                                            label: "Indexed Pages",
                                                                            propName: "totalIndexedPages",
                                                                            printPropName: "indexedPages.results",
                                                                        };

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business ${
                                                                                    business === "business" ? "" : "competitor"
                                                                                }`}
                                                                            >
                                                                                {business.totalIndexedPages ? (
                                                                                    <button
                                                                                        className="btn btn-link p-0 btn-json-output"
                                                                                        title={business.totalIndexedPages}
                                                                                        onClick={() =>
                                                                                            printJsonNodeValue(index, printSetting)
                                                                                        }
                                                                                    >
                                                                                        <span>{business.totalIndexedPages}</span>
                                                                                    </button>
                                                                                ) : (
                                                                                    <span className="json-output-no-value">0</span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>

                                                                {/* Backlinks */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditBacklinks"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditBacklinks}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website backlinks data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Backlinks</td>
                                                                    {auditKeywordData.map((business, index) => (
                                                                        <td
                                                                            key={index}
                                                                            className={`business ${
                                                                                business === "business" ? "" : "competitor"
                                                                            }`}
                                                                        >
                                                                            {business.totalBacklinks ? (
                                                                                <button
                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                    title={business.totalBacklinks}
                                                                                >
                                                                                    <span>{business.totalBacklinks}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="json-output-no-value">0</span>
                                                                            )}
                                                                        </td>
                                                                    ))}
                                                                </tr>

                                                                {/* Total Citations */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditCitations"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditCitations}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website citations data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Total Citations</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        let printSetting = {
                                                                            label: "Citations",
                                                                            propName: "totalCitations",
                                                                            printPropName: "citations.results",
                                                                        };

                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business ${
                                                                                    business === "business" ? "" : "competitor"
                                                                                }`}
                                                                            >
                                                                                {business.totalCitations ? (
                                                                                    <Fragment>
                                                                                        <button
                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                            onClick={() =>
                                                                                                printJsonNodeValue(index, printSetting)
                                                                                            }
                                                                                        >
                                                                                            <span>{business.totalCitations}</span>
                                                                                        </button>
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    <span className="json-output-no-value">0</span>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>

                                                                <tr>
                                                                    <td colSpan={6} className="separator-row">
                                                                        <strong>Keywords In:</strong>
                                                                    </td>
                                                                </tr>

                                                                {/* Keywords In Settings */}
                                                                {kwSettings.map((setting) => (
                                                                    <tr key={setting.label}>
                                                                        <td className="checkbox">
                                                                            {setting.checkboxName && (
                                                                                <input
                                                                                    name={`isSelectedAudit${setting.checkboxName}`}
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={
                                                                                        auditFormData[
                                                                                            `isSelectedAudit${setting.checkboxName}`
                                                                                        ]
                                                                                    }
                                                                                    onChange={handleCheckboxSelect}
                                                                                    title="Check to update business profile data"
                                                                                />
                                                                            )}
                                                                        </td>
                                                                        <td className="description">{setting.label}</td>
                                                                        {auditKeywordData.map((business, index) => {
                                                                            let propValue = business[setting.propName];
                                                                            let hoverPropValue = business.keywordsIn
                                                                                ? business.keywordsIn[setting.hoverPropName]
                                                                                : "";

                                                                            return (
                                                                                <td
                                                                                    key={index}
                                                                                    className={`business ${
                                                                                        business === "business" ? "" : "competitor"
                                                                                    }`}
                                                                                >
                                                                                    {propValue ? (
                                                                                        <Fragment>
                                                                                            {setting.printPropName ? (
                                                                                                <button
                                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                                    title={hoverPropValue}
                                                                                                    onClick={() =>
                                                                                                        printJsonNodeValue(index, setting)
                                                                                                    }
                                                                                                >
                                                                                                    <span>
                                                                                                        {isNumber(propValue)
                                                                                                            ? propValue
                                                                                                            : "Yes"}
                                                                                                    </span>
                                                                                                </button>
                                                                                            ) : (
                                                                                                <span
                                                                                                    className="btn-json-output"
                                                                                                    title={hoverPropValue}
                                                                                                >
                                                                                                    <span>
                                                                                                        {isNumber(propValue)
                                                                                                            ? propValue
                                                                                                            : "Yes"}
                                                                                                    </span>
                                                                                                </span>
                                                                                            )}
                                                                                        </Fragment>
                                                                                    ) : (
                                                                                        // <button
                                                                                        // 	className="btn btn-link p-0 btn-json-output"
                                                                                        // 	title={hoverPropValue}
                                                                                        // 	onClick={() =>
                                                                                        // 		printJsonNodeValue(
                                                                                        // 			index,
                                                                                        // 			setting
                                                                                        // 		)}
                                                                                        // >
                                                                                        // 	<span className="json-output-no-value">
                                                                                        // 		{isNumber(propValue) ? (
                                                                                        // 			0
                                                                                        // 		) : (
                                                                                        // 			'No'
                                                                                        // 		)}
                                                                                        // 	</span>
                                                                                        // </button>
                                                                                        <span className="json-output-no-value">
                                                                                            {isNumber(propValue) ? 0 : "No"}
                                                                                        </span>
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}

                                                                {/* Power Content */}
                                                                {powerContentWebsites && powerContentWebsites.length > 0 && (
                                                                    <Fragment>
                                                                        <tr>
                                                                            <td className="separator-row checkbox">
                                                                                <input
                                                                                    name="isSelectedAuditPowerContent"
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={auditFormData.isSelectedAuditPowerContent}
                                                                                    onChange={(e) =>
                                                                                        checkUncheckPowerContentItems(e.target.checked)
                                                                                    }
                                                                                    title="Check to update all power content websites"
                                                                                />
                                                                            </td>
                                                                            <td colSpan={5} className="separator-row">
                                                                                Power Content
                                                                            </td>
                                                                        </tr>
                                                                        {powerContentWebsites.map((pc, pcIndex) => {
                                                                            let websiteSlug = pc.websiteUrl
                                                                                .replace("https://", "")
                                                                                .replace("www.", "")
                                                                                .replace(".", "__")
                                                                                .replace("/", "___");
                                                                            let websiteHost = pc.websiteUrl
                                                                                .replace("https://", "")
                                                                                .replace("www.", "");
                                                                            let websiteChecked =
                                                                                auditFormData &&
                                                                                auditFormData.isSelectedAuditPowerContentItems
                                                                                    ? auditFormData.isSelectedAuditPowerContentItems.some(
                                                                                          (x) => x === websiteSlug,
                                                                                      )
                                                                                    : false;
                                                                            return (
                                                                                <tr key={pcIndex}>
                                                                                    <td className="separator-row checkbox">
                                                                                        <input
                                                                                            name={`isSelectedAuditPowerContent${websiteSlug}`}
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            checked={websiteChecked}
                                                                                            onChange={handleCheckboxSelect}
                                                                                            title="Check to update power content"
                                                                                        />
                                                                                    </td>
                                                                                    <td className="description">{websiteHost}</td>
                                                                                    {auditKeywordData.map((business, index) => {
                                                                                        let pcValue = business.totalPowerContent
                                                                                            ? business.totalPowerContent[websiteHost]
                                                                                            : false;
                                                                                        let printSetting = {
                                                                                            label: "Power Content",
                                                                                            propName: pc.websiteUrl,
                                                                                            printPropName: `powerContent.${websiteSlug}`,
                                                                                        };

                                                                                        return (
                                                                                            <td
                                                                                                key={index}
                                                                                                className={`business ${
                                                                                                    business === "business"
                                                                                                        ? ""
                                                                                                        : "competitor"
                                                                                                }`}
                                                                                            >
                                                                                                {pcValue ? (
                                                                                                    <Fragment>
                                                                                                        <button
                                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                                            onClick={() =>
                                                                                                                printJsonNodeValue(
                                                                                                                    index,
                                                                                                                    printSetting,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>Yes</span>
                                                                                                        </button>
                                                                                                    </Fragment>
                                                                                                ) : (
                                                                                                    <span className="json-output-no-value">
                                                                                                        No
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </Fragment>
                                                                )}

                                                                <tr>
                                                                    <td className="border border-secondary border-2 p-0" colSpan={6} />
                                                                </tr>

                                                                {/* Power Citations */}
                                                                {powerCitationsWebsites && powerCitationsWebsites.length > 0 && (
                                                                    <Fragment>
                                                                        <tr>
                                                                            <td className="separator-row checkbox">
                                                                                <input
                                                                                    name="isSelectedAuditPowerCitations"
                                                                                    className="form-check-input"
                                                                                    type="checkbox"
                                                                                    checked={auditFormData.isSelectedAuditPowerCitations}
                                                                                    onChange={(e) =>
                                                                                        checkUncheckPowerCitationsItems(e.target.checked)
                                                                                    }
                                                                                    title="Check to update power citations data for all websites"
                                                                                />
                                                                            </td>
                                                                            <td colSpan={5} className="separator-row">
                                                                                Power Citations
                                                                            </td>
                                                                        </tr>
                                                                        {powerCitationsWebsites.map((pc, pcIndex) => {
                                                                            let websiteSlug = pc.websiteUrl
                                                                                .replace("https://", "")
                                                                                .replace("www.", "")
                                                                                .replace(".", "__")
                                                                                .replace("/", "___");
                                                                            let websiteChecked =
                                                                                auditFormData &&
                                                                                auditFormData.isSelectedAuditPowerCitationsItems
                                                                                    ? auditFormData.isSelectedAuditPowerCitationsItems.some(
                                                                                          (x) => x === websiteSlug,
                                                                                      )
                                                                                    : false;
                                                                            return (
                                                                                <tr key={pcIndex}>
                                                                                    <td className="separator-row checkbox">
                                                                                        <input
                                                                                            name={`isSelectedAuditPowerCitations${websiteSlug}`}
                                                                                            className="form-check-input"
                                                                                            type="checkbox"
                                                                                            checked={websiteChecked}
                                                                                            onChange={handleCheckboxSelect}
                                                                                            title="Check to update power citations"
                                                                                        />
                                                                                    </td>
                                                                                    <td className="description">
                                                                                        {pc.websiteUrl.replace("https://", "")}
                                                                                    </td>
                                                                                    {auditKeywordData.map((business, index) => {
                                                                                        let pcItem =
                                                                                            business.powerCitations &&
                                                                                            business.powerCitations.length > 0
                                                                                                ? business.powerCitations.find(
                                                                                                      (x) =>
                                                                                                          x.website.indexOf(pc.websiteUrl) >
                                                                                                          -1,
                                                                                                  )
                                                                                                : null;
                                                                                        let printSetting = {
                                                                                            label: "Power Citations",
                                                                                            propName: pc.websiteUrl,
                                                                                            printPropName: `powerCitations.${websiteSlug}`,
                                                                                        };

                                                                                        return (
                                                                                            <td
                                                                                                key={index}
                                                                                                className={`business ${
                                                                                                    business === "business"
                                                                                                        ? ""
                                                                                                        : "competitor"
                                                                                                }`}
                                                                                            >
                                                                                                {pcItem && pcItem.total ? (
                                                                                                    <Fragment>
                                                                                                        <button
                                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                                            title={pcItem.total}
                                                                                                            onClick={() =>
                                                                                                                printJsonNodeValue(
                                                                                                                    index,
                                                                                                                    printSetting,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            <span>Yes</span>
                                                                                                        </button>
                                                                                                    </Fragment>
                                                                                                ) : (
                                                                                                    <span className="json-output-no-value">
                                                                                                        No
                                                                                                    </span>
                                                                                                )}
                                                                                            </td>
                                                                                        );
                                                                                    })}
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </Fragment>
                                                                )}

                                                                <tr>
                                                                    <td className="border border-secondary border-2 p-0" colSpan={6} />
                                                                </tr>

                                                                {/* Review Score */}
                                                                <tr>
                                                                    <td className="separator-row checkbox" />
                                                                    <td className="separator-row">Review Score</td>
                                                                    {auditKeywordData.map((business, index) => (
                                                                        <td key={index} className="separator-row" />
                                                                    ))}
                                                                </tr>

                                                                {/* Total Reviews */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditTotalReviews"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditTotalReviews}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website reviews data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Total Reviews</td>
                                                                    {auditKeywordData.map((business, index) => (
                                                                        <td key={index} className="business">
                                                                            {business.totalReviews ? (
                                                                                <button
                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                    title={business.totalReviews}
                                                                                    onClick={() => printReviewsList(index, "total")}
                                                                                >
                                                                                    <span>{business.totalReviews}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="json-output-no-value">0</span>
                                                                            )}
                                                                        </td>
                                                                    ))}
                                                                </tr>

                                                                {/* Average Rating */}
                                                                <tr>
                                                                    <td className="checkbox" />
                                                                    <td className="description">Average Rating</td>
                                                                    {auditKeywordData.map((business, index) => (
                                                                        <td key={index} className="business">
                                                                            {business.averageRating ? (
                                                                                <button
                                                                                    className="btn btn-link p-0 btn-json-output"
                                                                                    title={business.averageRating}
                                                                                    onClick={() => printReviewsList(index, "total")}
                                                                                >
                                                                                    <span>{business.averageRating}</span>
                                                                                </button>
                                                                            ) : (
                                                                                <span className="json-output-no-value">0</span>
                                                                            )}
                                                                        </td>
                                                                    ))}
                                                                </tr>

                                                                {/* Reviews Last 30 Days */}
                                                                <tr>
                                                                    <td className="separator-row checkbox">
                                                                        <input
                                                                            name="isSelectedAuditReviewsLast30Days"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditReviewsLast30Days}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website reviews data in the last 30 days"
                                                                        />
                                                                    </td>
                                                                    <td colSpan={5} className="separator-row">
                                                                        <strong>Last 30 Days</strong>
                                                                    </td>
                                                                </tr>
                                                                {reviewsLast30DaysSettings.map((setting) => (
                                                                    <tr key={setting.label}>
                                                                        <td className="checkbox" />
                                                                        <td className="description">{setting.label}</td>
                                                                        {auditKeywordData.map((business, index) => {
                                                                            let propValue = business[setting.propName];

                                                                            if (
                                                                                typeof propValue == "number" &&
                                                                                !isNaN(propValue) &&
                                                                                !Number.isInteger(propValue)
                                                                            ) {
                                                                                propValue = parseFloat(propValue).toFixed(1);
                                                                            }

                                                                            return (
                                                                                <td
                                                                                    key={index}
                                                                                    className={`business ${
                                                                                        business === "business" ? "" : "competitor"
                                                                                    }`}
                                                                                >
                                                                                    {propValue ? (
                                                                                        <button
                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                            onClick={() =>
                                                                                                printReviewsList(
                                                                                                    index,
                                                                                                    "last30Days",
                                                                                                    setting.propName,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <span>{propValue}</span>
                                                                                        </button>
                                                                                    ) : (
                                                                                        <span className="json-output-no-value">0</span>
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}

                                                                {/* Last 20 Reviews */}
                                                                <tr>
                                                                    <td className="separator-row checkbox">
                                                                        <input
                                                                            name="isSelectedAuditReviewsLast20"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditReviewsLast20}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website last 20 reviews data"
                                                                        />
                                                                    </td>
                                                                    <td colSpan={5} className="separator-row">
                                                                        <strong>Last 20 Reviews</strong>
                                                                    </td>
                                                                </tr>
                                                                {reviewsLast20Settings.map((setting) => (
                                                                    <tr key={setting.label}>
                                                                        <td className="checkbox" />
                                                                        <td className="description">{setting.label}</td>
                                                                        {auditKeywordData.map((business, index) => {
                                                                            let propValue = business[setting.propName];

                                                                            if (
                                                                                typeof propValue == "number" &&
                                                                                !isNaN(propValue) &&
                                                                                !Number.isInteger(propValue)
                                                                            ) {
                                                                                propValue = parseFloat(propValue).toFixed(1);
                                                                            }

                                                                            return (
                                                                                <td
                                                                                    key={index}
                                                                                    className={`business ${
                                                                                        business === "business" ? "" : "competitor"
                                                                                    }`}
                                                                                >
                                                                                    {propValue ? (
                                                                                        <button
                                                                                            className="btn btn-link p-0 btn-json-output"
                                                                                            onClick={() =>
                                                                                                printReviewsList(
                                                                                                    index,
                                                                                                    "last20",
                                                                                                    setting.propName,
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <span>{propValue}</span>
                                                                                        </button>
                                                                                    ) : (
                                                                                        <span className="json-output-no-value">0</span>
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                    </tr>
                                                                ))}

                                                                {/* Most Relevant Review Age */}
                                                                <tr>
                                                                    <td className="checkbox">
                                                                        <input
                                                                            name="isSelectedAuditReviewsMostRelevant"
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={auditFormData.isSelectedAuditReviewsMostRelevant}
                                                                            onChange={handleCheckboxSelect}
                                                                            title="Check to update website most relevant reviews data"
                                                                        />
                                                                    </td>
                                                                    <td className="description">Most Relevant Review Age</td>
                                                                    {auditKeywordData.map((business, index) => {
                                                                        return (
                                                                            <td
                                                                                key={index}
                                                                                className={`business ${
                                                                                    business === "business" ? "" : "competitor"
                                                                                }`}
                                                                            >
                                                                                {business.mostRelevantReviewAge ? (
                                                                                    <button
                                                                                        className="btn btn-link p-0 btn-json-output"
                                                                                        onClick={() =>
                                                                                            printReviewsList(index, "mostRelevant")
                                                                                        }
                                                                                    >
                                                                                        <span>
                                                                                            {business.mostRelevantReviewAge.replace(
                                                                                                " ago",
                                                                                                "",
                                                                                            )}
                                                                                        </span>
                                                                                    </button>
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            </tbody>
                                                        ) : (
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={6}>
                                                                        <i>No Data</i>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        )}
                                                    </table>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    {/* summary */}
                                    <div
                                        className="tab-pane fade"
                                        id="summary-report-tab-pane"
                                        role="tabpanel"
                                        aria-labelledby="summary-report-tab"
                                        tabIndex="0"
                                    >
                                        <div className="summary-data-container p-3">
                                            <div className="accordion" id="accordionSummary">
                                                {/* Profile Optimization */}
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button
                                                            className="accordion-button"
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseProfileOptimization"
                                                            aria-expanded="true"
                                                            aria-controls="collapseProfileOptimization"
                                                        >
                                                            Profile Optimization
                                                        </button>
                                                    </h2>
                                                    <div
                                                        id="collapseProfileOptimization"
                                                        className="accordion-collapse collapse show"
                                                        data-bs-parent="#accordionSummary"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="summary-data-container">
                                                                {summaryData && (
                                                                    <Fragment>
                                                                        <div className="row">
                                                                            <div className="col-12 col-sm-6">
                                                                                <div className="my-2 text-center">
                                                                                    Optimization Checklist
                                                                                </div>
                                                                                <div className="summary-messages-container">
                                                                                    {summaryChecklistItems &&
                                                                                    summaryChecklistItems.length ? (
                                                                                        <Fragment>
                                                                                            {summaryChecklistItems.map((item, index) => (
                                                                                                <Fragment key={index}>
                                                                                                    {item && (
                                                                                                        <div
                                                                                                            className="message-item"
                                                                                                            key={index}
                                                                                                        >
                                                                                                            <span className="icon">
                                                                                                                <i className="fas fa-check" />
                                                                                                            </span>
                                                                                                            <span className="ms-2">
                                                                                                                {item.message}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Fragment>
                                                                                            ))}
                                                                                        </Fragment>
                                                                                    ) : (
                                                                                        <div className="message-item">No items</div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-12 col-sm-6">
                                                                                <div className="my-2 text-center">Competitor Analysis</div>
                                                                                <div className="summary-messages-container">
                                                                                    {summaryCompetitionItems &&
                                                                                    summaryCompetitionItems.length ? (
                                                                                        <Fragment>
                                                                                            {summaryCompetitionItems.map((item, index) => (
                                                                                                <Fragment key={index}>
                                                                                                    {item && (
                                                                                                        <div
                                                                                                            className="message-item"
                                                                                                            key={index}
                                                                                                        >
                                                                                                            <span className="icon">
                                                                                                                <i className="fas fa-check" />
                                                                                                            </span>
                                                                                                            <span className="ms-2">
                                                                                                                {item.message}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Fragment>
                                                                                            ))}
                                                                                        </Fragment>
                                                                                    ) : (
                                                                                        <div className="message-item">No items</div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Fragment>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Keyword Optimization */}
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button
                                                            className="accordion-button collapsed"
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#collapseKeywordOptimization"
                                                            aria-expanded="false"
                                                            aria-controls="collapseKeywordOptimization"
                                                        >
                                                            Keyword Optimization
                                                        </button>
                                                    </h2>
                                                    <div
                                                        id="collapseKeywordOptimization"
                                                        className="accordion-collapse collapse"
                                                        data-bs-parent="#accordionSummary"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="optimization-data-container">
                                                                {summaryData && (
                                                                    <div className="row">
                                                                        <div className="col-12 col-sm-6">
                                                                            <div className="my-2 text-center">Optimization Checklist</div>
                                                                            <div className="summary-messages-container">
                                                                                {summaryChecklistItemsByKeyword &&
                                                                                summaryChecklistItemsByKeyword.length ? (
                                                                                    <Fragment>
                                                                                        {summaryChecklistItemsByKeyword.map(
                                                                                            (item, index) => (
                                                                                                <Fragment key={index}>
                                                                                                    {item && (
                                                                                                        <div
                                                                                                            className="message-item"
                                                                                                            key={index}
                                                                                                        >
                                                                                                            <span className="icon">
                                                                                                                <i className="fas fa-check" />
                                                                                                            </span>
                                                                                                            <span className="ms-2">
                                                                                                                {item.message}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Fragment>
                                                                                            ),
                                                                                        )}
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    <div className="message-item">No items</div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 col-sm-6">
                                                                            <div className="my-2 text-center">Competitor Analysis</div>
                                                                            <div className="summary-messages-container">
                                                                                {summaryCompetitionItemsByKeyword &&
                                                                                summaryCompetitionItemsByKeyword.length ? (
                                                                                    <Fragment>
                                                                                        {summaryCompetitionItemsByKeyword.map(
                                                                                            (item, index) => (
                                                                                                <Fragment key={index}>
                                                                                                    {item && (
                                                                                                        <div
                                                                                                            className="message-item"
                                                                                                            key={index}
                                                                                                        >
                                                                                                            <span className="icon">
                                                                                                                <i className="fas fa-check" />
                                                                                                            </span>
                                                                                                            <span className="ms-2">
                                                                                                                {item.message}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Fragment>
                                                                                            ),
                                                                                        )}
                                                                                    </Fragment>
                                                                                ) : (
                                                                                    <div className="message-item">No items</div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* compare */}
                                    <div
                                        className="tab-pane fade"
                                        id="compare-report-tab-pane"
                                        role="tabpanel"
                                        aria-labelledby="compare-report-tab"
                                        tabIndex="0"
                                    >
                                        <div className="compare-data-container p-3">...</div>
                                    </div>
                                </div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                {(!gridData || isGenerating || isLoadingMap) && (
                                    <div className="loading-map">
                                        <Spinner />
                                        {loadingMessage && <div className="loading-message">{loadingMessage}</div>}
                                    </div>
                                )}

                                {gridData && (
                                    <GridMapV5
                                        key="map-preview"
                                        mapIdValue="report-map-preview"
                                        gridData={gridData}
                                        placeId={gridData.googlePlaceId}
                                        isFullHeight={true}
                                        showCircle={true}
                                        circleRadius={areaRadius}
                                        onCircleMove={handleCircleMove}
                                        reportSettings={reportSettings}
                                    />
                                )}
                            </Fragment>
                        )}
                    </Fragment>

                    <div className="info-wrapper border border-top-0">
                        {companyData && companyData.googleBusinessUrl && (
                            <Fragment>
                                <div className="company-profile-url info-item">
                                    <span>
                                        <a className="btn btn-link p-0" target="_blank" href={companyData.googleBusinessUrl}>
                                            <span>Profile Url</span>
                                            <i className="fa-solid fa-up-right-from-square ms-2" />
                                        </a>
                                    </span>
                                </div>
                                <div className="info-item-separator">|</div>
                            </Fragment>
                        )}

                        <Fragment>
                            <div className="company-profile-url info-item">
                                <span>Grid Size:</span>
                                {selectedTask ? (
                                    <span className="ms-2">{`${selectedTask.gridPoints}x${selectedTask.gridPoints}`}</span>
                                ) : reportTasks && reportTasks.length > 0 && reportTasks[0].gridPoints ? (
                                    <span className="ms-2">{`${reportTasks[0].gridPoints}x${reportTasks[0].gridPoints}`}</span>
                                ) : (
                                    <Fragment />
                                )}
                            </div>
                            <div className="info-item-separator">|</div>
                            <div className="company-profile-url info-item">
                                <span>Radius:</span>
                                <span className="ms-2">{`${areaRadius} miles`}</span>
                            </div>
                            <div className="info-item-separator">|</div>
                            <div className="company-profile-url info-item">
                                <span>Point Distance:</span>
                                {selectedTask ? (
                                    <span className="ms-2">{`${parseFloat((areaRadius * 2) / (selectedTask.gridPoints - 1)).toFixed(
                                        2,
                                    )} miles`}</span>
                                ) : reportTasks && reportTasks.length > 0 && reportTasks[0].gridPoints ? (
                                    <span className="ms-2">{`${parseFloat((areaRadius * 2) / (reportTasks[0].gridPoints - 1)).toFixed(
                                        2,
                                    )} miles`}</span>
                                ) : (
                                    <Fragment />
                                )}
                            </div>
                            <div className="info-item-separator">|</div>
                            {showGridReport ? (
                                <Fragment>
                                    {selectedTask && selectedTask.lat && selectedTask.lng && (
                                        <div className="company-profile-url info-item">
                                            <span>Lat/Lng:</span>
                                            <span className="ms-2">{`${parseFloat(selectedTask.lat).toFixed(5)}, ${parseFloat(
                                                selectedTask.lng,
                                            ).toFixed(5)}`}</span>
                                        </div>
                                    )}
                                </Fragment>
                            ) : (
                                <Fragment>
                                    {gridData && gridData.lat && gridData.lng && (
                                        <div className="company-profile-url info-item">
                                            <span>Lat/Lng:</span>
                                            <span className="ms-2">{`${parseFloat(gridData.lat).toFixed(5)}, ${parseFloat(
                                                gridData.lng,
                                            ).toFixed(5)}`}</span>
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    </div>

                    {showJsonOutputDialog && (
                        <ModalDialog className="text-start" position="right-sidebar">
                            <ModalDialogContent align="start">
                                <div className="json-output-container">
                                    <div className="row" dangerouslySetInnerHTML={{ __html: jsonOutput }} />
                                </div>
                            </ModalDialogContent>
                            <ModalDialogButtons>
                                <div className="row">
                                    <div className="text-start col-12">
                                        <button className="btn btn-outline-primary" onClick={toggleJsonOutputDialog}>
                                            <span>Close</span>
                                        </button>
                                    </div>
                                </div>
                            </ModalDialogButtons>
                        </ModalDialog>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GridReportTool;
